let SHOP = 'nbn-data-setup.myshopify.com';
let STOREFRONT_TOKEN = '70bc02637513e57dbfafb5526e3972f6';
  console.log('window.shop',window.shop)
if(window.shop == 'golftechuk.myshopify.com'){
   SHOP = 'ninebyninegolf.myshopify.com';
   STOREFRONT_TOKEN = 'b50c3ff4d3d2cbc7da628ad6c1fa6343';
}

const API_VERSION = '2025-10'; // change if needed
// Fetch only shaft products by product_type using Storefront API (paginated).
// Node/browser (fetch must be available). Replace SHOP and STOREFRONT_TOKEN.

const FLEX_GROUPS = {
  Ladies: [
    "ladies", "l", "regular 3", "sf305", "4.0", "3.5", "m0", "f1"
  ],
  Senior: [
    "senior", "a", "soft regular", "sf305x", "5.0", "f2", "regular 2", "m1"
  ],
  Regular: [
    "regular", "r", "regular 1", "sf405", "5.5", "f3", "regular +", "r300", "m2"
  ],
  Stiff: [
    "stiff", "s", "stiff regular", "sf505", "6.0", "f4", "s200", "stiff +", "m3"
  ],
  "X-Stiff": [
    "x stiff", "xstiff", "x", "sf505x", "6.5", "f5", "x100", "m4", "m5"
  ],
  "Tour X-Stiff": [
    "tour x stiff", "tx", "tx (tour x-stiff)", "7.0", "sf505xx"
  ]
};

function slugify(input, options = {}) {
  if (!input) return '';

  const {
    separator = '-',
    lowercase = true,
    strict = true, // remove special chars aggressively
    trim = true
  } = options;

  let str = String(input);

  // Normalize accents (é → e, ö → o)
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (lowercase) {
    str = str.toLowerCase();
  }

  // Replace non-alphanumeric characters
  if (strict) {
    str = str.replace(/[^a-z0-9]+/g, separator);
  } else {
    str = str.replace(/[^\w]+/g, separator);
  }

  // Remove duplicate separators
  const sepRegex = new RegExp(`${separator}{2,}`, 'g');
  str = str.replace(sepRegex, separator);

  // Trim separators from start/end
  if (trim) {
    const trimRegex = new RegExp(`^${separator}|${separator}$`, 'g');
    str = str.replace(trimRegex, '');
  }

  return str;
}


// ========== VARIABLE INITIALIZATION ==========
window.__selectedGrip = null;
window.__selectedIronSet = {
  flex: null,
  model: null,
  irons: [],                 // ['3i','7i','9i','PW']
  variantsByIron: {},        // { '3i': variantId, ... }
  variantIds: []             // [variantId, variantId, ...]
};
window.__selectedGripOptions = {
  logoOrientation: 'up' // default
};

window.__selectedHeadVariants = [];
window.__currentBuild = window.__currentBuild || { irons: [] };

window.__selectedDexterity = 'Left Hand'; // default, will be overwritten by toggle


// ========== VARIABLE INITIALIZATION ENDS ==========


async function shopifyGraphQL(query, variables = {}) {
  const url = `https://${SHOP}/api/${API_VERSION}/graphql.json`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  if (!res.ok) throw new Error(`HTTP ${res.status} - ${await res.text()}`);
  const payload = await res.json();
  if (payload.errors) throw new Error(JSON.stringify(payload.errors));
  return payload.data;
}

/**
 * Fetch shafts by product_type values.
 *
 * types: array of product_type strings e.g. ['Iron Shaft','Wood Shaft']
 * opts:
 *   pageSize: products per page (default 100, max around 250)
 *   variantFirst: how many variants to fetch per product page (default 50)
 *   variantSkus: optional array of SKUs to narrow returned variants (case-insensitive)
 *
 * Returns: [{ id, title, productType, variants: [{ id, title, sku, priceAmount, available }] }, ...]
 */
async function fetchShaftsByTypes(types = ['Iron Shaft','Wood Shaft'], opts = {}) {
  const pageSize = opts.pageSize || 100;
  const variantFirst = opts.variantFirst || 50;
  const variantSkus = (opts.variantSkus || []).map(s => (s||'').toString().toLowerCase());
  // build product_type query: product_type:'Iron Shaft' OR product_type:'Wood Shaft'
  const safeParts = types.map(t => `product_type:'${String(t).replace(/'/g,"\\'")}'`);
  const typeQuery = safeParts.join(' OR ');

  let after = null;
  const out = [];

  while (true) {
    const query = /* GraphQL */ `
      query GetShafts($first: Int!, $after: String, $query: String!, $variantFirst: Int!, $country: CountryCode) @inContext(country: $country) {
        products(first: $first, after: $after, query: $query) {
          edges {
            cursor
            node {
              id
              handle
              title
              vendor
              productType
              availableForSale
              featuredImage{
                url
              }
              adapter_settings:metafield(namespace: "custom", key: "adapter_settings") {
                value
                id
              }
              default_adapter_settings:metafield(namespace: "custom", key: "default_adapter_settings") {
                value
                id
              }
             shortDescription: metafield(namespace:"custom",key:"short_description"){
                value
                id
              }
               recommended: metafield(namespace:"custom",key:"is_recommended"){
                value
                id
                }
                zeroUpcharge: metafield(namespace:"custom",key:"is_zero_upcharge"){
                value
                id
                }
                default_length: metafield(namespace:"custom",key:"default_length"){
                  value          
                  id
                }
               tip_size: metafield(namespace:"custom",key:"tip_size"){
                  value          
                  id
                }
               neck: metafield(namespace:"custom",key:"neck"){
                  value          
                  id
                }
               tip_fit: metafield(namespace:"custom",key:"tip_fit"){
                  value          
                  id
                }
               neck_fit: metafield(namespace:"custom",key:"neck_fit"){
                  value          
                  id
                }
               material: metafield(namespace:"custom",key:"material"){
                  value          
                  id
                }
               pre_selected_grip: metafield(namespace:"custom",key:"pre_selected_grip"){
                  value          
                  id
                }
               pre_selected_shaft: metafield(namespace:"custom",key:"pre_selected_shaft"){
                  value          
                  id
                }
               ball_spin: metafield(namespace:"custom",key:"ball_spin"){
                  value          
                  id
                }
               ball_flight: metafield(namespace:"custom",key:"ball_flight"){
                  value          
                  id
                }
               shaft_profile: metafield(namespace:"custom",key:"shaft_profile"){
                  value          
                  id
                }
              shaftThumb: metafield(namespace: "custom", key: "shaftThumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
                gripthumb: metafield(namespace: "custom", key: "gripthumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
              variants(first: $variantFirst) {
                pageInfo { hasNextPage }
                edges {
                  node {
                    id
                    title
                    sku
                    price { amount currencyCode }
                    selectedOptions{
                      name
                      value
                    }
                    default_length: metafield(namespace:"custom",key:"default_length"){
                      value          
                      id
                    }
                    iron_fit: metafield(namespace:"custom",key:"iron_fit"){
                      value          
                      id
                    }
                    iron: metafield(namespace:"custom",key:"iron"){
                      value          
                      id
                    }
                  }
                }
              }
            }
          }
          pageInfo { hasNextPage }
        }
      }
    `;
    const variables = { first: pageSize, after, query: typeQuery, variantFirst, country: Shopify?.country || "GB" };
    const data = await shopifyGraphQL(query, variables);
    const edges = (data.products && data.products.edges) || [];

    for (const edge of edges) {
      const p = edge.node;
      // flatten first page of variants
      let variants = (p.variants.edges || []).map(e => {
        const v = e.node;

        // Convert selectedOptions array → object
        const optionMap = {};
        (v.selectedOptions || []).forEach(opt => {
          optionMap[opt.name.toLowerCase()] = opt.value;
        });

        return {
          id: v.id,
          title: v.title,
          sku: v.sku,
          priceAmount: v.price ? Number(v.price.amount) : null,

          // raw options
          options: optionMap,
          iron_fit:v.iron_fit?.value || [],
          default_length:v.default_length || '',
          iron:v.iron?.value || '',
          // normalized fields (what your UI actually needs)
          flex: optionMap.flex || null,
          model: optionMap.model || null,
        };
      });


      // if variantSkus provided but not all SKUs present on first page, you can page remaining variants.
      // For performance we only fetch remaining variants if variantSkus is provided AND some requested SKUs are missing.
      const skusRequested = variantSkus.length > 0;
      if (skusRequested) {
        const presentSkus = new Set(variants.map(v => (v.sku||'').toLowerCase()));
        const missing = variantSkus.filter(sku => !presentSkus.has(sku));
        if (missing.length && p.variants.pageInfo && p.variants.pageInfo.hasNextPage) {
          // fetch all variants for this product (page through) to find requested SKUs
          const more = await fetchAllVariantsForProduct(p.id);
          // append unique variants
          const existingIds = new Set(variants.map(v => v.id));
          for (const mv of more) {
            if (!existingIds.has(mv.id)) {
              variants.push(mv);
            }
          }
        }
        // filter to only requested SKUs (case-insensitive)
        variants = variants.filter(v => variantSkus.includes((v.sku||'').toLowerCase()));
      }

      // console.log('product shortDescription:: ',renderShopifyRTE(p.shortDescription?.value))
      // if variantSkus not provided, we keep whatever variants were fetched (first page)
      // console.log('iron_fit',p)
      out.push({
        id: p.id,
        handle: p.handle,
        title: p.title,
        productType: p.productType,
        vendor: p.vendor,
        featuredImage: p.featuredImage?.url || '',
        variants:variants,
        availableForSale:p.availableForSale,
        recommended:p.recommended?.value || false,
        zeroUpcharge:p.zeroUpcharge?.value || false,
        default_length:p.default_length?.value || "",
        tip_size:p.tip_size?.value || "",
        neck_fit:p.neck_fit?.value || "",
        material:p.material?.value || "",
        ball_flight:p.ball_flight?.value || "",
        ball_spin:p.ball_spin?.value || "",
        shaft_profile:p.shaft_profile?.value || "",
        pre_selected_grip:p.pre_selected_grip?.value || false,
        shortDescription:renderShopifyRTE(p.shortDescription?.value) || "",
        shaftThumb:p.shaftThumb,
        gripthumb:p.gripthumb,
        adapter_settings:p.adapter_settings?.value | "",
        default_adapter_settings:p.default_adapter_settings?.value | "",
      });
    }

    if (!data.products.pageInfo.hasNextPage) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }

  return out;
}

/**
 * Helper: fetch all variants for a product (cursor-based). Returns same variant shape used above.
 * Use only when necessary (keeps normal calls fast).
 */
async function fetchAllVariantsForProduct(productGid) {
  const perPage = 50;
  let after = null;
  const all = [];
  while (true) {
    const query = /* GraphQL */ `
      query ProductVariants($id: ID!, $first: Int!, $after: String, $country: CountryCode) @inContext(country: $country) {
        node(id: $id) {
          ... on Product {
            variants(first: $first, after: $after) {
              pageInfo { hasNextPage }
              edges {
                node { id title sku price { amount currencyCode } }
                cursor
              }
            }
          }
        }
      }
    `;
    // Map the currency to a Country Code if Shopify.country isn't available
    const countryMapping = { 'USD': 'US', 'GBP': 'GB', 'EUR': 'FR', 'SEK': 'SE', 'CAD': 'CA' };
    const activeCountry = Shopify?.country || countryMapping[Shopify.currency.active] || 'GB';
    const data = await shopifyGraphQL(query, { id: productGid, first: perPage, after, country: activeCountry });
    const edges = (data.node && data.node.variants && data.node.variants.edges) || [];
    for (const e of edges) {
      const v = e.node;
      all.push({
        id: v.id,
        title: v.title,
        sku: v.sku,
        priceAmount: v.price ? v.price.amount : null
      });
    }
    if (!(data.node && data.node.variants && data.node.variants.pageInfo && data.node.variants.pageInfo.hasNextPage)) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }
  return all;
}

// Get the current club config from your JSON
const currentClubConfig = CONFIG.clubs_head_type[currentProduct?.type]; // e.g., "Driver"

// Helper to calculate final price
const getFinalPrice = (basePrice, discountPercent) => {
    const discountAmount = (basePrice * (discountPercent || 0)) / 100;
    const finalPrice = basePrice - discountAmount;
    return Math.max(0, finalPrice); // Ensure price never goes below 0
};


function showSectionLoader(sectionId) {
  document
    .querySelector(`#${sectionId} .config-loader`)
    ?.classList.remove('hidden');

  if (sectionId === 'shaft-step') {
    document
      .querySelectorAll('#open-shaft-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'none';
        btn.disabled = true;
      });
  }

  if (sectionId === 'grip-step') {
    document
      .querySelectorAll('#open-grip-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'none';
        btn.disabled = true;
      });
  }
}


function hideSectionLoader(sectionId) {
  // Hide loader for this section
  document
    .querySelector(`#${sectionId} .config-loader`)
    ?.classList.add('hidden');

  // Show only the relevant button
  if (sectionId === 'shaft-step') {
    document
      .querySelectorAll('#open-shaft-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'block';
        btn.disabled = false;
      });
  }

  if (sectionId === 'grip-step') {
    document
      .querySelectorAll('#open-grip-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'block';
        btn.disabled = false;
      });
  }
}


function getShopifyImageUrl(src, { width, height, crop } = {}) {
  if (!src || typeof src !== 'string') return src;

  // Ignore non-Shopify CDN images
  if (!src.includes('cdn.shopify.com')) return src;

  // Split query params
  const [url, query] = src.split('?');

  // Extract extension
  const match = url.match(/\.(jpg|jpeg|png|webp)$/i);
  if (!match) return src;

  const ext = match[0];
  const base = url.replace(ext, '');

  // Build size suffix
  let size = '';
  if (width && height) size = `_${width}x${height}`;
  else if (width) size = `_${width}x`;

  // Rebuild URL
  let finalUrl = `${base}${size}${ext}`;
  if (query) finalUrl += `?${query}`;

  // Optional crop (center, top, etc.)
  if (crop) {
    finalUrl += (query ? '&' : '?') + `crop=${crop}`;
  }

  return finalUrl;
}


function normalizeBool(val) {
  return val === true || val === 'true' || val === 1 || val === '1';
}


function getProductImage(product) {
  return (
    product?.shaftThumb?.reference?.image?.url || ""
  );
}

function getProductImageGrip(product) {
  return (
    product?.gripthumb?.reference?.image?.url || ""
  );
}

function getBrandConfigForCurrentHead() {
  const vendor = (window.currentProduct?.vendor || "").toLowerCase();
  if (!vendor) return null;

  return META_BRANDS.find(
    b => (b.title || "").toLowerCase() === vendor
  ) || null;
}


function getNumericProductId(gid) {
  if (!gid) return null;

  const match = String(gid).match(/Product\/(\d+)/);
  return match ? Number(match[1]) : null;
}

function renderShopifyRTE(rte) {
  if (!rte) return "";

  let data;
  try {
    data = typeof rte === "string" ? JSON.parse(rte) : rte;
  } catch (e) {
    return "";
  }

  if (!data || !Array.isArray(data.children)) return "";

  return data.children.map(renderRTENode).join("");
}

function renderRTENode(node) {
  if (!node) return "";

  switch (node.type) {
    case "paragraph":
      return `<p>${(node.children || []).map(renderRTENode).join("")}</p>`;

    case "text": {
      let text = escapeHtml(node.value || "");

      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;

      return text.replace(/\n/g, "<br>");
    }

    case "heading": {
      const level = node.level || 3;
      return `<h${level}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</h${level}>`;
    }

    case "list":
      const tag = node.listType === "ordered" ? "ol" : "ul";
      return `<${tag}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</${tag}>`;

    case "list-item":
      return `<li>${(node.children || [])
        .map(renderRTENode)
        .join("")}</li>`;

    default:
      return "";
  }
}

function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function buildInfoAccordion(rteDescription) {
  const html = rteDescription;
  if (!html) return "";

  return `
    <div class="nbn-info-accordion">
      <button class="nbn-info-toggle" type="button" aria-expanded="false">
          INFO <span class="icon-info-plus-minus"></span>
      </button>
      <div class="nbn-info-content" hidden>
        ${html}
      </div>
    </div>
  `;
}



function extractProductIdFromMetafield(value) {
  if (!value) return null;

  // CASE 1: Shopify already gives numeric product ID (YOUR CASE)
  if (typeof value.id === 'number') {
    return value.id;
  }

  // CASE 2: id is a GID string
  if (typeof value.id === 'string') {
    return getNumericProductId(value.id);
  }

  // CASE 3: whole value is a GID string
  if (typeof value === 'string') {
    return getNumericProductId(value);
  }

  return null;
}


function getPreSelectedShaftNumericId() {
  const mf = window.currentProduct?.metafields?.pre_selected_shaft;
  const resolved = extractProductIdFromMetafield(mf);

  // console.log('[DEBUG] pre_selected_shaft raw:', mf);
  // console.log('[DEBUG] resolved numeric ID:', resolved);

  return resolved;
}


function getAdapterOptions() {
  const brand = getBrandConfigForCurrentHead();
  if (!brand || !Array.isArray(brand.adapter_settings)) {
    return null;
  }

  return {
    options: brand.adapter_settings,
    default: brand.default_adapter || brand.adapter_settings[0]
  };
}

function isIronProduct() {
  return (
    window.currentProduct?.type &&
    window.currentProduct.type.toLowerCase().includes("iron")
  );
}


function buildSpineTooltip() {
  return `
    <div class="nbn-tooltip">
      Aligning the shaft’s natural spine to ensure consistent performance and reduce unwanted flex during the swing.
    </div>
  `;
}




function buildInitialShaftOrder(groupedProducts) {
  // 🔥 IRONS: no recommended, no preselected, show all
  // if (isIronProduct()) {
  //   return {
  //     preSelected: [],
  //     recommended: [],
  //     zeroUpcharge: [],
  //     others: groupedProducts.slice() // show everything
  //   };
  // }

  // ===== existing logic for Driver / Wood / Hybrid =====

  const preSelectedId = Number(getPreSelectedShaftNumericId());

  const buckets = {
    preSelected: [],
    recommended: [],
    zeroUpcharge: [],
    others: []
  };

  groupedProducts.forEach(p => {
    const pid = getNumericProductId(p.productId);

    if (preSelectedId && pid === preSelectedId) {
      buckets.preSelected.push(p);
      return;
    }

    if (normalizeBool(p.recommended)) {
      buckets.recommended.push(p);
      return;
    }

    if (normalizeBool(p.zeroUpcharge)) {
      buckets.zeroUpcharge.push(p);
      return;
    }

    buckets.others.push(p);
  });

  // console.log('buckets',buckets)
  return buckets;
}






function getLengthConfigForCurrentHead() {
  const headType = window.currentProduct?.type;
  // console.log('getLengthConfigForCurrentHead headType',headType)
  if (!headType) return null;

  const headCfg = CONFIG?.clubs_head_type?.[headType];
  // console.log('getLeng headCfg:: ',headCfg)
  if (!headCfg || !headCfg.length_to_pull) return null;

  return window.META_LENGTHS.find(
    l => l.for_type === headCfg.length_to_pull
  ) || null;
}


function normalizeFlexValue(raw) {
  if (!raw) return '';

  return raw
    .toString()
    .toLowerCase()
    .replace(/\//g, ' ')
    .replace(/\+/g, ' plus')
    .replace(/\s+/g, ' ')
    .trim();
}

function resolveFlexGroup(variantFlexText) {
  const norm = normalizeFlexValue(variantFlexText);

  for (const [group, aliases] of Object.entries(FLEX_GROUPS)) {
    if (aliases.some(a => norm.includes(a))) {
      return group;
    }
  }

  return null; // unknown / uncategorized
}

/**
 * Grips Helper Starts
 */

function formatKey(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}


function renderVariantRadios({ variants, selectedVariant, onChange, containerId }) {
  const container = document.getElementById(containerId);
  if (!container || !variants.length) return;

  container.innerHTML = "";

  // 1. Get all keys but EXCLUDE 'iron'
  const optionKeys = Object.keys(variants[0].options || {})
                           .filter(key => key.toLowerCase() !== 'iron');
  
  if (!optionKeys.length) return;

  // 2. Determine currently selected variant
  let current = selectedVariant && variants.find(v => v.variantId === selectedVariant.variantId)
                ? selectedVariant 
                : variants.find(v => v.available) || variants[0];

  // 3. Chained filtering pool
  let filteredPool = variants;

  optionKeys.forEach((key) => {
    // values available based on PREVIOUS selections (chained)
    const availableValues = [...new Set(filteredPool.map(v => v.options[key]))].filter(Boolean);
    
    // all possible values for this key (to show them as disabled/hidden if needed)
    const allPossibleValuesForKey = [...new Set(variants.map(v => v.options[key]))].filter(Boolean);

    container.insertAdjacentHTML("beforeend", `
      <div class="variant-group" data-option="${key}">
        <label>${key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</label>
        <div class="variant-radios" data-key="${key}"></div>
      </div>
    `);

    const wrap = container.querySelector(`[data-key="${key}"]`);

    allPossibleValuesForKey.forEach(val => {
      const isPossible = availableValues.includes(val);
      const isChecked = current.options[key] === val;

      wrap.insertAdjacentHTML("beforeend", `
        <label class="iron-flex-option radio-option ${isPossible ? "" : "disabled hidden-option"}">
          <input type="radio"
                 name="${containerId}-${key}"
                 value="${val}"
                 ${isChecked ? "checked" : ""}
                 ${isPossible ? "" : "disabled"}>
          <span>${val}</span>
        </label>
      `);
    });

    // 4. Narrow the pool for the NEXT option loop based on what is CURRENTLY selected
    const currentSelectionForKey = current.options[key];
    filteredPool = filteredPool.filter(v => v.options[key] === currentSelectionForKey);
  });

  // console.log('variants',variants);
  bindVariantRadioEvents({ variants, containerId, onChange });
}

function bindVariantRadioEvents({ variants, containerId, onChange }) {
  const container = document.getElementById(containerId);

  container.querySelectorAll("input[type=radio]").forEach(radio => {
    radio.addEventListener("change", () => {
      const selections = {};

      container.querySelectorAll("input:checked").forEach(r => {
        const key = r.name.replace(containerId + "-", "");
        selections[key] = r.value;
      });

      // 1. Try to find exact match
      let next = variants.find(v =>
        Object.entries(selections).every(([k, val]) => v.options[k] === val)
      );

      // 2. Fallback: If combination is invalid, find first variant matching the FIRST selection
      if (!next) {
        const firstKey = Object.keys(selections)[0];
        next = variants.find(v => v.options[firstKey] === selections[firstKey] && v.available) ||
               variants.find(v => v.options[firstKey] === selections[firstKey]);
      }

      if (next) {
        onChange(next);
        renderVariantRadios({
          variants,
          selectedVariant: next,
          containerId,
          onChange
        });
      }
    });
  });
}



function getCurrentSelections(containerId) {
  const selections = {};
  const container = document.getElementById(containerId);

  container.querySelectorAll("input:checked").forEach(r => {
    const key = r.name.replace(containerId + "-", "");
    selections[key] = r.value;
  });

  return selections;
}

function buildShaftOptionSummary(variant) {
  if (!variant || !variant.options) {
    return { optionLabel: "", optionValue: "" };
  }

  const entries = Object.entries(variant.options);

  return {
    optionLabel: entries.map(([k]) =>
      k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    ).join(" / "),
    optionValue: entries.map(([, v]) => v).join(" / ")
  };
}

function drawerClose(id) {
  const drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.classList.remove("active");
}


function getPreSelectedGripNumericId() {
  return extractProductIdFromMetafield(
    window.currentProduct?.metafields?.pre_selected_grip
  );
}



/************** 
 * Grips Helper Starts
 * **************
 */

function updateGripPriceUI() {
  const el = document.querySelector('.nbn-grip-price');
  // 1. Safety checks: element exists, grip is selected, and config is available
  if (!el || !window.__selectedGrip || !currentClubConfig) return;

  // 2. Calculate the price
  const minBasePrice = Math.min(...window.__selectedGrip.product.variants.map(v => v.price));
  
  // Use GRIP discount here, not shaft
  const discount = currentClubConfig.grip_discount_amount || 0;
  
  // Assuming getFinalPrice is defined globally as discussed:
  const finalPrice = getFinalPrice(minBasePrice, discount);

  // 3. Render the HTML
  const isZeroUpcharge = normalizeBool(window.__selectedGrip.product.zeroUpcharge) || finalPrice <= 0;

  el.innerHTML = getPriceDisplayHTML(minBasePrice,discount,window.__selectedGrip.product.zeroUpcharge,'grip')
}

function initPreSelectedGrip(grips) {
  // console.log('grips',grips)
  const preId = getPreSelectedGripNumericId();
  if (!preId) return;

  const grip = grips.find(g => getNumericProductId(g.productId) === preId);
  if (!grip || !grip.variants.length) return;

  // console.log('preselected grip product',grip)
  
  const v = grip.variants[0];
  const { label, value } = buildVariantOptionSummary(v.options);
  const summary = buildShaftOptionSummary(v);
  window.__selectedGrip = {
    productId: grip.productId,
    productTitle: grip.productTitle,
    variantId: v.variantId,
    price: Number(v.price||0) ,
    featuredImage: grip.featuredImage,
    brand: grip.vendor,
    ...summary,
    product:grip,
    variant:v,
  };

  // console.log('window.__selectedGrip',window.__selectedGrip)

  updateSelectedGripLabel(window.__selectedGrip);
  renderSelectedGripSummary(window.__selectedGrip);

  updateBuildPrice();
  updateGripPriceUI();

  // console.log('window.__selectedGrip 766',window.__selectedGrip)
  if (window.__selectedGrip) {
    renderGripVariantRadios(window.__selectedGrip.product);
  }
  if(document.getElementById("open-grip-drawer")){
      document.getElementById("open-grip-drawer").style.display ='block';
  }
}

async function initGripFlow() {
  const headType = currentProduct.type;
  const cfg = CONFIG?.clubs_head_type?.[headType];
  
  if (!cfg?.grips_to_pull) return;

  let grips = await fetchShaftsByTypes(
    cfg.grips_to_pull.map(normalizeProductTypeLabel),
    { pageSize: 50, variantFirst: 50 }
  );

  // console.log(cfg)

  // 1. Group by product
  const groupedGrips = groupGripsByProduct(flattenGrips(grips));

  // 2. Sort into buckets
  const buckets = {
    recommended: [],
    zeroUpcharge: [],
    others: []
  };

  groupedGrips.forEach(grip => {
    const preId = getPreSelectedGripNumericId();
    const isPreSelected = getNumericProductId(grip.productId) === preId;
    
    if (isPreSelected) {
      buckets.recommended.push(grip);
    } else if (normalizeBool(grip.zeroUpcharge)) {
      buckets.zeroUpcharge.push(grip);
    } else {
      buckets.others.push(grip);
    }
  });

  // 3. SET THE STATE
  // initPreSelectedGrip usually handles what shows on the main product page initially
  initPreSelectedGrip(groupedGrips);

  // 4. INITIALIZE THE DRAWER
  // We pass 'buckets' here. The drawer init function will handle the rendering 
  // of results inside the drawer so we don't have to call it twice.
  initGripDrawer(buckets);
  
  // console.log('Grip Flow Initialized with Buckets:', buckets);
}

function renderGroupedGripBuckets(buckets) {
  const container = document.getElementById('grip-results');
  if (!container) return;
  container.innerHTML = '';

  // 1. Render Recommended (Will hide automatically if empty)
  renderGripSection('Recommended for You', buckets.recommended);

  // 2. Render Zero Upcharge (Will hide automatically if empty)
  renderGripSection('Zero Upcharge Grips', buckets.zeroUpcharge);

  // 🔥 FIX 2: Determine if "All Grips" should be collapsed
  // We only collapse "All Grips" if there is at least one item in the priority sections above it.
  const hasPriorityItems = (buckets.recommended?.length > 0) || (buckets.zeroUpcharge?.length > 0);
  const shouldCollapseOthers = hasPriorityItems;

  // 3. Render All Others
  renderGripSection('All Grips', buckets.others, shouldCollapseOthers);
}

function renderGripSection(title, products, collapsible = false) {
  // 🔥 FIX 1: If there are no products, exit immediately to hide the header
  if (!products || products.length === 0) return;

  const container = document.getElementById('grip-results');
  const section = document.createElement('div');
  section.className = 'shaft-section grip-section'; 

  section.innerHTML = `
    <h3 class="shaft-section-title">${title}</h3>
    <div class="shaft-section-list"></div>
  `;

  const list = section.querySelector('.shaft-section-list');
  products.forEach(p => renderGripProduct(p, list));

  // Only collapse if requested AND we actually have content to hide
  if (collapsible) {
    section.classList.add('is-collapsed');
  }

  container.appendChild(section);
}

function flattenGrips(products) {
  // console.log('grup products:: ',products)
  const out = [];
  products.forEach(p => {
    (p.variants || []).forEach(v => {
      out.push({
        productId: p.id,
        productTitle: p.title,
        variantTitle: v.title,
        featuredImage: getShopifyImageUrl(p.featuredImage, { width: 280 }),
        variantId: v.id,
        vendor: p.vendor,
        available: p.availableForSale,
        price: Number(v.priceAmount||0),                
        shortDescription: p.shortDescription || '',
        short_title: p.short_title || '',
        recommended: p.recommended || false,
        zeroUpcharge: p.zeroUpcharge || false,
        options:v.options,
        gripthumb:p.gripthumb,
        shaftThumb:p.shaftThumb,
        productType: p.productType || '',
        adapter_settings: p.adapter_settings || '',
        default_adapter_settings: p.default_adapter_settings || '',
      });
    });
  });
  return out;
}

function groupGripsByProduct(items) {
  const map = new Map();

  items.forEach(i => {
    // console.log('grip map ',i)
    if (!map.has(i.productId)) {
      map.set(i.productId, {
        productId: i.productId,
        productTitle: i.productTitle,
        variantTitle: i.variantTitle,
        featuredImage: i.featuredImage,
        variantId: i.variantId,
        vendor: i.vendor,
        available: i.availableForSale,
        price: Number(i.priceAmount||0),                
        shortDescription: i.shortDescription || '',
        short_title: i.short_title || '',
        recommended: i.recommended || false,
        zeroUpcharge: i.zeroUpcharge || false,
        options:i.options,
        gripthumb:i.gripthumb,
        shaftThumb:i.shaftThumb,
        productType: i.productType || '',
        variants: []
      });
    }
    map.get(i.productId).variants.push({
      variantId: i.variantId,
      price: i.price,
      color: i.color,
      size: i.size,
      price: Number(i.price || 0),
      available: i.available,
      options:i.options
    });
  });

  return [...map.values()];
}

function bindShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Remove existing listeners to prevent duplicates if init is called multiple times
  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.addEventListener('click', () => {
    expandAllGripSections();
    // After expanding, we check if we need to hide the button
    updateShowAllGripsButton();
  });

  // Initial check to see if button should be visible
  updateShowAllGripsButton();
}

function expandAllGripSections() {
  // Target only grip sections specifically
  document
    .querySelectorAll('#grip-results .shaft-section.is-collapsed') 
    .forEach(section => section.classList.remove('is-collapsed'));
}

function updateShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Logic: Show button ONLY if filters are NOT active AND there are hidden sections
  const show = !hasActiveGripFilters() && hasCollapsedGripSections();
  
  btn.style.display = show ? 'block' : 'none';
}

function hasCollapsedGripSections() {
  // Returns true if any section in the grip results is currently collapsed
  return document.querySelectorAll('#grip-results .shaft-section.is-collapsed').length > 0;
}

function hasActiveGripFilters() {
  // Check your specific ID for the grip brand filter dropdown
  const brandFilter = document.getElementById('grip-brand-select'); // or 'grip-brand-filter'
  
  // If filter exists and value is not "All", return true
  return brandFilter && brandFilter.value !== 'all' && brandFilter.value !== '';
}


function populateGripBrandFilter(grips) {
  const sel = document.getElementById("filter-grip-brand");
  if (!sel) return;

  // Reset with "All" option
  sel.innerHTML = `<option value="__all__" selected>All brands</option>`;

  const brands = [...new Set(grips.map(g => g.vendor).filter(v => v && v.trim()))].sort();

  brands.forEach(b => {
    const o = document.createElement("option");
    o.value = b;
    o.textContent = b;
    sel.appendChild(o);
  });
}


function bindGripFilters() {
  const vendorSelect = document.getElementById("filter-grip-brand");
  const searchInput = document.getElementById("grip-search");
  
  if (!vendorSelect || !searchInput) return;

  const handleFilter = () => {
    const selectedVendor = vendorSelect.value;
    const searchText = searchInput.value.toLowerCase().trim();

    // Check if any filter is actually active (assuming empty string or "__all__" is default)
    const isFilterActive = (selectedVendor !== "__all__" && selectedVendor !== "") || searchText !== "";

    // --- SCENARIO 1: NO FILTERS ACTIVE ---
    // Restore the original "Recommended / Zero Upcharge" layout
    if (!isFilterActive) {
      renderGroupedGripBuckets(window.__gripBuckets);
      updateShowAllGripsButton(); // Show the "Show All" button if sections are collapsed
      return;
    }

    // --- SCENARIO 2: FILTERS ACTIVE ---
    // 1. Flatten the buckets so we can search through EVERYTHING
    const allGrips = [
      ...(window.__gripBuckets.recommended || []),
      ...(window.__gripBuckets.zeroUpcharge || []),
      ...(window.__gripBuckets.others || [])
    ];

    // 2. Apply Filters
    const filtered = allGrips.filter(grip => {
      // Check Brand/Vendor
      const matchesVendor = (selectedVendor === "__all__" || selectedVendor === "") || 
                            grip.vendor === selectedVendor;
      
      // Check Search Text
      const matchesSearch = !searchText || 
                            (grip.productTitle && grip.productTitle.toLowerCase().includes(searchText)) || 
                            (grip.vendor && grip.vendor.toLowerCase().includes(searchText));

      return matchesVendor && matchesSearch;
    });

    // 3. Render "Search Results" Mode
    const container = document.getElementById('grip-results');
    container.innerHTML = ''; // Clear current view

    if (filtered.length > 0) {
      // Reuse renderGripSection to keep styling consistent, but don't collapse it
      renderGripSection(`All Grips`, filtered, false);
    } else {
      container.innerHTML = '<div class="no-results" style="padding: 20px; text-align: center;">No grips found matching your criteria.</div>';
    }

    // 4. Update Button Visibility
    // This effectively hides the "Show All" button while searching, which is good UX
    updateShowAllGripsButton();
  };

  // Listen for dropdown changes
  vendorSelect.addEventListener("change", handleFilter);

  // Listen for typing in the search box
  searchInput.addEventListener("input", handleFilter);
}


function initGripDrawer(buckets) {
  const drawer = document.getElementById("grip-drawer");
  if (!drawer) return;

  // 1. Accordion Logic (Info Toggles)
  // We use a named function to prevent duplicate listeners if init is called twice
  const handleAccordionClick = e => {
    const toggle = e.target.closest(".nbn-info-toggle");
    if (!toggle) return;
    e.stopPropagation();
    e.preventDefault();
    const accordion = toggle.closest(".nbn-info-accordion");
    accordion.classList.toggle("open");
  };
  
  // Clean up old listener before adding (good practice)
  document.removeEventListener("click", handleAccordionClick);
  document.addEventListener("click", handleAccordionClick);

  // 2. Close Logic
  document.getElementById("close-grip-drawer")
    ?.addEventListener("click", () => drawer.classList.remove("active"));

  // 3. Store Buckets Globally 
  // We store the whole bucket object so filters can access specific sections if needed
  window.__gripBuckets = buckets;

  // 4. Flatten all grips for the Brand Filter
  // Filters usually need a single list of all unique brands
  const allGripsFlat = [
    ...buckets.recommended, 
    ...buckets.zeroUpcharge, 
    ...buckets.others
  ];
  
  populateGripBrandFilter(allGripsFlat);

  // 5. Render the grouped UI
  // Instead of a flat list, we render the sections
  renderGroupedGripBuckets(buckets);

  // 6. Bind UI filters
  bindGripFilters();

  // 7. 🔥 BIND THE SHOW ALL BUTTON HERE
  bindShowAllGripsButton();

  // 8. Open Drawer Listeners
  document.querySelectorAll("#open-grip-drawer, #open-grip-drawer-btn").forEach(btn =>
    btn.addEventListener("click", (e) => {
      drawer.classList.add("active");
    })
  );
}

// /**
//  * Calculates price after fixed discount and returns formatted HTML
//  * @param {number} basePrice - The raw price (e.g., 50.00)
//  * @param {number} discountAmount - The fixed £ to subtract (e.g., 35)
//  * @param {boolean} isZeroUpcharge - The product's zeroUpcharge flag
//  * @param {string} unit - 'shaft' or 'grip'
//  */
// function getPriceDisplayHTML(basePrice, discountAmount, isZeroUpcharge, unit) {
//     // Simple subtraction for fixed amounts
//     const finalPrice = Math.max(0, basePrice - (discountAmount || 0));

//     if (normalizeBool(isZeroUpcharge) || finalPrice <= 0) {
//         return `<div class="price price-zero">Zero Upcharge</div>`;
//     } else {
//         // toFixed(2) ensures it still looks like £15.00
//         return `<div class="price Math-min">+${theme.currencySymbol}${finalPrice.toFixed(2)}/${unit}</div>`;
//     }
// }

/**
 * @param {number|string} shaftPrice - Price from GraphQL (already converted/rounded by Shopify)
 * @param {number} discountBase - Discount in GBP (e.g., 35)
 * @param {boolean} isZeroUpcharge - Metafield check
 * @param {string} unit - Label (e.g., "shaft")
 */
function getPriceDisplayHTML(shaftPrice, discountBase, isZeroUpcharge, unit = "shaft") {
    const { rate = 1.0, active = 'GBP' } = Shopify.currency || {};
    const marketFee = (active === 'GBP') ? 1.0 : 1.02; // Accounts for the 2% fee in your Market settings

    // 1. Normalize input to decimal (not cents) to make raw math easier
    let currentPrice = parseFloat(shaftPrice);
    
    // 2. Convert the Discount to the current Market currency
    // GBP Discount * Exchange Rate * 2% Fee
    const convertedDiscount = Number(discountBase) * parseFloat(rate) * marketFee;

    // 3. Subtract from the already-rounded price (raw math)
    const finalPrice = Math.max(0, currentPrice - convertedDiscount);

    if (isZeroUpcharge || finalPrice <= 0) {
        return `<div class="price price-zero">Zero Upcharge</div>`;
    }

    // 4. Formatting - Removed the applyMarketRounding call here
    
    // Using Intl.NumberFormat to force 2 decimal places regardless of currency settings
    const formattedPrice = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(finalPrice);

    return `<div class="price">+${formattedPrice}/${unit}</div>`;
}

function renderGripProduct(grip, container) {
  const v = grip.variants[0];
  const el = document.createElement("div");
  
  // Clean up class logic: Use 'current-selected' as the primary state class
  el.className = "option_product";
  el.dataset.vendor = grip.vendor;

  // --- 1. INITIAL HIGHLIGHT CHECK ---
  // Ensure the product stays highlighted if the drawer is re-rendered
  if (window.__selectedGrip && window.__selectedGrip.productId === grip.productId) {
    // console.log('window.__selectedGrip',window.__selectedGrip)
    el.classList.add('current-selected');
  }

  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
  el.innerHTML = `
    <div class="option">
      <div class="option_head">
        <h4>${grip.short_title || grip.productTitle}</h4>
        ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}        
      </div>
      <div class="option_img">
        <img src="${getProductImageGrip(grip)}" loading="lazy">
      </div>
    </div>
  `;

  el.addEventListener('click', () => {
    // --- 2. UPDATE VISUAL SELECTION STATE ---
    // We target the entire results container to clear selection across ALL sections (Recommended/Others)
    document.querySelectorAll('#grip-results .option_product').forEach(item => {
      item.classList.remove('current-selected');
    });
    
    // Add class to the clicked element
    el.classList.add('current-selected');

    const variant = grip.variants.find(v => v.available) || grip.variants[0];
    const summary = buildShaftOptionSummary(variant);

    // Update Global State
    window.__selectedGrip = {
      productId: grip.productId,
      productTitle: grip.productTitle,
      variantId: variant.variantId,
      price: Number(variant.price || 0),
      featuredImage: grip.featuredImage,
      vendor: grip.vendor,
      ...summary,
      product: grip,
      variant: variant
    };

    // --- 3. UI UPDATES ---
    updateSelectedGripLabel(window.__selectedGrip);
    renderSelectedGripSummary(window.__selectedGrip);
    
    // Renders the size/color radios for the specific grip chosen
    renderGripVariantRadios(grip);

    updateBuildPrice();
    updateGripPriceUI();

    // Close drawer and show the "Change Grip" button
    document.getElementById("grip-drawer")?.classList.remove("active");
    const openBtn = document.getElementById("open-grip-drawer");
    if (openBtn) {
      openBtn.style.display = 'block';
    }
  });

  container.appendChild(el);

  // Remove error state if selection is made
  const configStep = document.querySelector("#grip-step .gd-config");
  if (configStep) configStep.classList.remove('has-error');
}

function updateSelectedGripLabel(grip) {
  // console.log('updateSelectedGripLabel grip',grip)
  const el = document.getElementById("selected-grip-name");
  if (!el || !grip) return;

  el.innerHTML = `
    ${grip.productTitle}
    <br>
    <div class="shaft-meta">
      <span class="shaft-meta-label">${grip.optionLabel || ''}</span><br>
      <strong class="shaft-meta-value">${grip.optionValue || ''}</strong>
    </div>
  `;

  document.querySelector("#grip-step .gd-config").classList.remove('has-error');
}

function bindGripOptionEvents() {
  const logoToggle = document.getElementById("grip-logo-toggle");
  const tapeSelect = document.getElementById("grip-tape-select");

  if (logoToggle) {
    logoToggle.addEventListener("change", e => {
      window.__selectedGripOptions.logoOrientation =
        e.target.checked ? "down" : "up";

      console.log("Grip logo:", window.__selectedGripOptions.logoOrientation);
    });
  }

  if (tapeSelect) {
    tapeSelect.addEventListener("change", e => {
      window.__selectedGripOptions.gripTape = e.target.value;

      console.log("Grip tape:", window.__selectedGripOptions.gripTape);
    });
  }

  bindLogoOrientationToggle();
}

function bindLogoOrientationToggle() {
  const wrap = document.querySelector('#grip-step .gd-toggle');
  if (!wrap) return;

  const buttons = wrap.querySelectorAll('.gd-toggle-btn[data-logoorientation]');
  const switchInput = wrap.querySelector('.gd-switch-input');

  function setOrientation(value) {
    buttons.forEach(btn => {
      btn.setAttribute(
        'aria-pressed',
        btn.dataset.logoorientation === value ? 'true' : 'false'
      );
    });

    if (switchInput) {
      switchInput.checked = value === 'Down';
    }

    updateOrderButtonState();
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      setOrientation(btn.dataset.logoorientation);
    });
  });

  if (switchInput) {
    switchInput.addEventListener('change', e => {
      e.stopPropagation();
      setOrientation(switchInput.checked ? 'Down' : 'Up');
    });
  }
}

function renderGripVariantRadios(product) {
  if (!product || !product.variants?.length) return;

  renderVariantRadios({
    variants: product.variants,
    selectedVariant: window.__selectedGrip?.variant,
    containerId: "grip-variant-options",
    onChange: v => {
      window.__selectedGrip.variant = v;
      window.__selectedGrip.variantId = v.variantId;
      window.__selectedGrip.price = Number(v.price || 0);

      const summary = buildShaftOptionSummary(v);
      window.__selectedGrip.optionLabel = summary.optionLabel;
      window.__selectedGrip.optionValue = summary.optionValue;

      updateSelectedGripLabel(window.__selectedGrip);
      updateBuildPrice();
    }
  });
}


function renderSelectedGripSummary(grip) {
  if (!grip) return;

  const container = document.querySelector("#grip-step .js-set-selected-Grip");
  if (!container) return;

  // console.log('selcted grip',grip)
  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.product.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
    container.innerHTML = `
      <div class="nbn-step-card">
        <div class="nbn-step-right">

          <div class="nbn-grip-price">
            ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}
          </div>
          <div class="nbn-grip-image">
            <img
              src="${getProductImageGrip(grip.product)}"
              alt="${grip.productTitle}"
              loading="lazy"
              width="420"
            />
          </div>

          <!-- GRIP VARIANT OPTIONS -->
          <div id="grip-variant-options" class="nbn-variant-options"></div>

          <!-- LOGO ORIENTATION -->
          <div class="nbn-grip-logo">
            <div class="nbn-advanced">
              <div class="gd-toggle">
                <button class="gd-toggle-btn" data-logoorientation="Up" aria-pressed="true">Logo Up</button>
                <label class="gd-switch" aria-hidden="true">
                  <input type="checkbox" class="gd-switch-input">
                  <span class="gd-switch-slider"></span>
                </label>
                <button class="gd-toggle-btn" data-logoorientation="Down" aria-pressed="false">Logo Down</button>
              </div>
          </div>
          

          <!-- GRIP TAPE -->
          <div class="nbn-grip-tape nbn-custom-select">
            <label for="grip-tape-select">Grip Tape</label>

            <select id="grip-tape-select">
              <option value="1 Layer (Standard)" selected>1 Layer (Standard)</option>
              <option value="2 Layers">2 Layers</option>
              <option value="3 Layers">3 Layers</option>
              <option value="4 Layers">4 Layers</option>
            </select>
          </div>
          </div>

        </div>
      </div>
    `;

  bindGripOptionEvents();
  bindLogoOrientationToggle();   // ← ADD THIS

}


/************** 
 * Grips Helper Ends
 * **************
 */


// ========== All Helper Ends ==========


function bindIronSelectionEvents() {
  document.querySelectorAll('.gd-iron-input').forEach(el => {
    el.addEventListener('change', () => {
      updateSelectedIrons();
      updateBuildPrice();
      updateOrderButtonState();
    });
  });

  // Run once initially (in case some are prechecked)
  updateSelectedIrons();
  updateBuildPrice();
  updateOrderButtonState();
}



function buildVariants(product) {
  return (product?.variants || []).map(v => ({
    id: v.id,
    available: Boolean(v.available),
    options: Array.isArray(v.options) ? v.options : []
  }));
}

function resolveOptionIndexes(product) {
  let dexIndex = null;
  let ironsIndex = null;

  const options = product?.options_with_values || product?.options || [];

  options.forEach((opt, i) => {
    const name = (opt.name || opt || '').toLowerCase();
    if (/(dexter|hand|dexterity)/.test(name)) dexIndex = i;
    if (/(iron|loft|°)/.test(name)) ironsIndex = i;
  });

  return {
    dexIndex: dexIndex ?? 0,
    ironsIndex: ironsIndex ?? 1
  };
}




function normalizeProductTypeLabel(label) {
  if (!label || typeof label !== 'string') return label;

  let s = label.trim();
  s = s.replace(/\s+/g, ' ');
  s = s.replace(/Shafts$/i, 'Shaft');
  s = s.replace(/shafts$/i, 'Shaft'); // defensive

  return s;
}

function populateFlightSpinFilters(groupedProducts) {
  const flightSelect = document.getElementById('filter-flight');
  const spinSelect   = document.getElementById('filter-spin');

  if (!flightSelect || !spinSelect) return;

  // Reset (keep placeholder option)
  flightSelect.length = 1;
  spinSelect.length = 1;

  const flights = new Set();
  const spins   = new Set();

  groupedProducts.forEach(p => {
    if (p.ball_flight) flights.add(p.ball_flight);
    if (p.ball_spin) spins.add(p.ball_spin);
  });

  [...flights].sort().forEach(val => {
    const o = document.createElement('option');
    o.value = val;
    o.textContent = val;
    flightSelect.appendChild(o);
  });

  [...spins].sort().forEach(val => {
    const o = document.createElement('option');
    o.value = val;
    o.textContent = val;
    spinSelect.appendChild(o);
  });
}


function updateBuildPrice() {
  const irons = window.__selectedHeadVariants || [];
  // console.log('updateBuildPrice irons',irons)
  if (irons.length === 0) {
    const priceEl = document.querySelector('[data-product-price]');
    const unitEl = document.querySelector('.unit-price span');

    if (priceEl && window.__baseProductPrice != null) {
      priceEl.textContent = `${theme.currencySymbol}${window.__baseProductPrice.toFixed(2)}`;
    }

    if (unitEl) {
      unitEl.textContent = '';
    }

    return;
  }
  const shaft = window.__selectedShaftProduct;
  const grip = window.__selectedGrip;
  const ferrule = window.__ironAdjustments?.ferruleVariant;
  const spineVariant = window.__spineAlignment ? window.spine_alignment?.variants?.[0] : null;
  var shaftMinPrice = window.__selectedShaftProduct ? Math.min(...window.__selectedShaftProduct?.variants.map(v => v.price)) : 0;
  const ironCount = irons.length;
  if (ironCount === 0) return;

  // Iron head price (per iron)
  let ironHeadPrice = Number(irons[0]?.price || 0) / 100;

  let perIronAddon = ironHeadPrice;

  const { rate = 1.0, active = 'GBP' } = Shopify.currency || {};
  const marketFee = (active === 'GBP') ? 1.0 : 1.02; // Accounts for the 2% fee in your Market settings

  // 2. Shaft Logic
  let shaftPrice = 0;
  if (shaft) {
      const isShaftZero = shaft?.zeroUpcharge === true || shaft?.zeroUpcharge === "true";
      
      if (!isShaftZero) {
          const rawShaftPrice = Number(shaftMinPrice || 0);
          const shaftDiscountBase = currentClubConfig?.shaft_discount_amount || 0;
          
          // Convert the GBP discount to local currency including the 2% fee
          const convertedDiscount = shaftDiscountBase * rate * marketFee;
          
          // Calculate final price - NO ROUNDING - keep raw decimals
          shaftPrice = Math.max(0, rawShaftPrice - convertedDiscount);
      } else {
          shaftPrice = 0;
      }
      
      // Add raw decimal price to the iron total
      perIronAddon += Number(shaftPrice || 0);
  }

  // 3. Grip Logic
  let gripPrice = 0;
  if (grip) {
      const isGripZero = grip.product?.zeroUpcharge === true || grip.product?.zeroUpcharge === "true";
      
      if (!isGripZero) {
          const rawGripPrice = Number(grip.price || 0);
          const gripDiscountBase = currentClubConfig?.grip_discount_amount || 0;
          
          // Convert the GBP discount to local currency including the 2% fee
          const convertedGripDiscount = gripDiscountBase * rate * marketFee;
          
          // Calculate final price - NO ROUNDING
          gripPrice = Math.max(0, rawGripPrice - convertedGripDiscount);
      } else {
          gripPrice = 0;
      }
      
      // Add raw decimal price to the iron total
      perIronAddon += Number(gripPrice || 0);
  }

  // console.log('Final Calculated Prices:', { 
  //   shaftPrice: shaftPrice.toFixed(2), 
  //   gripPrice: gripPrice.toFixed(2) 
  // });

  if (ferrule && ferrule.title != "Standard") {
    perIronAddon += Number(ferrule.price || 0) / 100;
  }

  if (spineVariant) {
    perIronAddon += Number(spineVariant.price || 0) / 100;
  }

  // console.log('ironCount',ironCount, 'spineVariant',spineVariant,'shaft price: ',shaftPrice, 'gripPrice: ',gripPrice,perIronAddon)

  const total = ironCount * perIronAddon;

  const priceEl = document.querySelector('[data-product-price]');
  const unitEl = document.querySelector('.unit-price span');
  document.querySelector('.unit-price').classList.remove('hidden');

  if (priceEl) priceEl.textContent = `${theme.currencySymbol}${total.toFixed(2)}`;
  if (unitEl) unitEl.textContent = `${theme.currencySymbol}${perIronAddon.toFixed(2)}`;

  window.__currentBuild = {
    irons,
    shaft,
    grip,
    ferrule,
    spineVariant,
    ironCount,
    perIronAddon,
    total
  };
}





function buildVariantOptionSummary(options = {}) {
  const entries = Object.entries(options);

  if (!entries.length) {
    return {
      label: "",
      value: ""
    };
  }

  const label = entries
    .map(([key]) =>
      key
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase())
    )
    .join(" / ");

  const value = entries
    .map(([, val]) => val)
    .join(" / ");

  return { label, value };
}


async function initShaftFlow() {
  const headType = currentProduct.type;
  const cfg = CONFIG?.clubs_head_type?.[headType];
  console.log('cfg:: ',cfg)
  if (!cfg) return;

  const types = [...new Set(cfg.shafts_to_pull.map(normalizeProductTypeLabel))];

  const shafts = await fetchShaftsByTypes(types, {
    pageSize: 50,
    variantFirst: 250
  });

  // 1️⃣ flatten
  // console.log('Original shafts: ',shafts)
  const flatVariants = flattenShafts(shafts);
  // console.log('flatVariants: ',flatVariants)
  
  // 2️⃣ group
  const groupedProducts = groupShaftsByProduct(flatVariants);
  window.__flatIronVariants = groupedProducts.flatMap(p => p.variants);
  console.log('groupedProducts',groupedProducts)


  // 3️⃣ init drawer UI (THIS IS THE CALL)
  initShaftDrawer(groupedProducts);

  updateSelectedShaftLabel(window.__selectedShaft); // ✅ ADD
}

function renderShaftDrawer(products) {
  const container = document.getElementById("shaft-results");
  container.innerHTML = "";

  if (isIronProduct()) {
    products.forEach(p => renderIronShaftProduct(p, container));
  } else {
    // existing driver / wood logic
    renderGroupedShaftBuckets(buildInitialShaftOrder(products));
  }
}


function renderIronShaftProduct(product, container) {
  const card = document.createElement("div");
  card.className = "shaft-product-card";
  card.dataset.productId = product.productId;

  card.innerHTML = `
    <div class="shaft-product-head">
      <img src="${product.featuredImage}" alt="${product.productTitle}">
      <h4>${product.productTitle}</h4>
      <span class="price">From +${theme.currencySymbol}${product.minPrice || 0}</span>
    </div>
    <button class="select-shaft-btn">Select</button>
  `;

  card.querySelector(".select-shaft-btn").onclick = () => {
    onIronShaftProductSelected(product); // ⬅️ IMPORTANT
    closeShaftDrawer();
  };

  container.appendChild(card);
}

function getIronFits(variant) {
  const raw = variant.iron_fit?.value;

  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.warn("Invalid iron_fit JSON", raw, variant);
    return [];
  }
}


function buildIronFlexMap(variants, selectedIrons) {
  const flexMap = {};

  // Step 1: group variants by flex
  variants.forEach(variant => {
    const flex = (variant.flex || '').trim();
    if (!flex) return;

    if (!flexMap[flex]) {
      flexMap[flex] = {
        label: buildIronFlexLabel(flex, variant.model),
        model: variant.model || '',
        variants: [],
        coveredIrons: new Set()
      };
    }

    const fits = normaliseIronFit(variant);
    fits.forEach(i => flexMap[flex].coveredIrons.add(normaliseIronCode(i)));

    flexMap[flex].variants.push(variant);
  });

  // Step 2: validate coverage per flex
  const validFlexMap = {};

  Object.entries(flexMap).forEach(([flex, data]) => {
    const coversAll = selectedIrons.every(sel =>
      data.coveredIrons.has(normaliseIronCode(sel))
    );

    if (coversAll) {
      validFlexMap[flex] = data;
    }
  });

  return validFlexMap;
}

function buildIronFlexLabel(flex, model) {
  const weight = Number(model);

  if (!weight) return capitalizeFlex(flex);

  // Business rule: "+" for heavier iron shafts
  if (weight >= 120) {
    return `${capitalizeFlex(flex)} +`;
  }

  return capitalizeFlex(flex);
}

function capitalizeFlex(flex) {
  return flex.charAt(0).toUpperCase() + flex.slice(1).toLowerCase();
}




function getSelectedIrons() {
  return [...document.querySelectorAll('.gd-iron-input:checked')]
    .map(el => el.dataset.iron);
}

/**
 * Normalizes iron codes to a standard 9i variant for 
 * consistent shaft and ferrule matching.
 */
// function normaliseIronCode(iron) {
//   const i = iron.toLowerCase().trim();
  
//   // List of all "W" types to be treated as Pitching Wedges / Wedges
//   const wedgeTypes = ['pw', 'gw', 'sw', 'lw', 'aw', 'w'];
  
//   if (wedgeTypes.includes(i)) {
//     // Change this from '9i' to 'pw' (or 'wedge' depending on your shaft tags)
//     return 'pw'; 
//   }
  
//   return i;
// }

function normaliseIronCode(iron) {
  return iron.toLowerCase().trim();
}

function normaliseIronFit(variant) {
  try {
    const raw = Array.isArray(variant.iron_fit)
    ? variant.iron_fit
    : JSON.parse(variant.iron_fit || '[]');
    
    // console.log('variant.map',raw.map(normaliseIronCode))
    return raw.map(normaliseIronCode);
  } catch {
    return [];
  }
}

function initLoftLie() {
  // 1. Determine the club type from product data
  const productType = currentProduct?.type; // e.g., "Iron", "Hybrid", "Driving Iron"
  
  // 2. Look up the specific config for this head type
  const headConfig = CONFIG.clubs_head_type[productType];

  // 3. Safety Check: If no config exists, or both loft and lie are false, hide and exit
  const container = document.getElementById('loftlie-adjustments');
  if (!container) return;

  if (!headConfig || (!headConfig.loft && !headConfig.lie)) {
    container.style.display = 'none';
    return;
  }

  container.style.display = 'block';
  let htmlContent = '';

  // 4. Conditionally build Loft HTML
  if (headConfig.loft) {
    htmlContent += `
    <div class="nbn-advanced">
      <div class="nbn-shaft-length nbn-custom-select">
        <label>Loft</label>
        <select id="iron-loft-select">
          ${window.META_LOFTS.loft_values.map(v => `
            <option ${v === 'Standard' ? 'selected' : ''}>${v}</option>
          `).join('')}
        </select>
      </div>
    </div>`;
  }

  // 5. Conditionally build Lie HTML
  if (headConfig.lie) {
    htmlContent += `
    <div class="nbn-advanced">
      <div class="nbn-shaft-length nbn-custom-select">
        <label>Lie</label>
        <select id="iron-lie-select">
          ${window.META_LIES.lie_values.map(v => `
            <option ${v === 'Standard' ? 'selected' : ''}>${v}</option>
          `).join('')}
        </select>
      </div>
    </div>`;
  }

  container.innerHTML = htmlContent;
}

function renderIronAdjustments() {
  const container = document.getElementById('iron-adjustments');
  if (!container) return;

  const ferruleVariants = (window.ferrule_product?.variants || []);

  container.style.display = 'block';
  const defaultFerruleImg = getShopifyImageUrl(window.ferrule_product.featured_image, {width:60});

  container.innerHTML = `
  <div class="nbn-advanced">
    <div class="nbn-shaft-length nbn-custom-select">
      <label>Ferrule <img src="${getShopifyImageUrl(window.ferrule_product.featured_image,{width:60})}" class="ferrule_img"></label>
      <select id="iron-ferrule-select">
        ${ferruleVariants.map((v) => {
          // If variant has no image, use the product featured image
          const imgUrl = v.featured_image.src 
            ? getShopifyImageUrl(v.featured_image.src, {width:60}) 
            : defaultFerruleImg;
            // console.log('imgUrl',imgUrl)

          return `
            <option value="${v.id}" data-img="${imgUrl}">
              ${v.option1} ${v.option1 !== 'Standard' ? `(${theme.currencySymbol}${(v.price / 100).toFixed(2)})` : ''} 
            </option>
          `;
        }).join('')}
      </select>
    </div>
  </div>

  <div class="nbn-advanced">
    <div class="nbn-shaft-spine">
      <label class="nbn-checkbox">
      <span>Spine Alignment (+£10)</span>
        <input type="checkbox" id="iron-spine-checkbox" value="${window.spine_alignment.variants[0].id}">
      </label>

      <button
        class="nbn-info-btn"
        type="button"
        aria-label="Spine Alignment info"
      >
        i
        ${buildSpineTooltip()}
      </button>
    </div>
  </div>
  `;

  bindIronAdjustmentEvents();
}


document.addEventListener('change', (e) => {
  if (e.target.id === 'iron-ferrule-select') {
    const select = e.target;
    // Get the selected option element
    const selectedOption = select.options[select.selectedIndex];
    // Get the image URL from the data-img attribute
    const newImgUrl = selectedOption.getAttribute('data-img');
    
    // Find the image relative to the select box
    // It's inside the <label> which is usually a sibling or parent
    const ferruleImg = document.querySelector('.ferrule_img');
    
    if (ferruleImg && newImgUrl) {
      ferruleImg.src = newImgUrl;
    }
  }
});

// function bindIronAdjustmentEvents() {
//   window.__ironAdjustments = {
//     length: document.getElementById('shaft-length-select')?.value || 'Standard',
//     loft: document.getElementById('iron-loft-select')?.value || 'Standard',
//     lie: document.getElementById('iron-lie-select')?.value || 'Standard'
//     ferruleVariant: (window.ferrule_product?.variants || []).find(v => v.title === 'Standard'),
//     spine: false
//   };

//   document.getElementById('shaft-length-select')?.addEventListener('change', e => {
//     window.__ironAdjustments.length = e.target.value;
//   });

//   document.getElementById('iron-loft-select').addEventListener('change', e => {
//     window.__ironAdjustments.loft = e.target.value;
//   });

//   document.getElementById('iron-lie-select').addEventListener('change', e => {
//     window.__ironAdjustments.lie = e.target.value;
//   });

//   document.getElementById('iron-ferrule-select')?.addEventListener('change', e => {
//     const val = e.target.value;

//     // if (val === 'standard') {
//     //   window.__ironAdjustments.ferruleVariant = null;
//     // } else {
//     //   const id = Number(val);
//     //   const ferrule = (window.ferrule_product?.variants || []).find(v => v.id === id);
//     //   window.__ironAdjustments.ferruleVariant = ferrule || null;
//     // }
//     const id = Number(val);
//     const ferrule = (window.ferrule_product?.variants || []).find(v => v.id === id);
//     window.__ironAdjustments.ferruleVariant = ferrule || null;

//     updateBuildPrice();
//   });


//   document.getElementById('iron-spine-checkbox').addEventListener('change', e => {
//     window.__ironAdjustments.spine = e.target.checked;
//     window.__spineAlignment = e.target.checked;
//     updateBuildPrice();
//   });
// }

function bindIronAdjustmentEvents() {
  // Helper to sync the global state with actual DOM values
  const syncAdjustments = () => {
    const ferruleId = Number(document.getElementById('iron-ferrule-select')?.value);
    
    window.__ironAdjustments = {
      length: document.getElementById('shaft-length-select')?.value || 'Standard',
      loft: document.getElementById('iron-loft-select')?.value || 'Standard',
      lie: document.getElementById('iron-lie-select')?.value || 'Standard',
      // Find variant based on current select value
      ferruleVariant: (window.ferrule_product?.variants || []).find(v => v.id === ferruleId) || null,
      spine: document.getElementById('iron-spine-checkbox')?.checked || false
    };
    
    // Keep secondary global sync if needed for other scripts
    window.__spineAlignment = window.__ironAdjustments.spine;
  };

  // Initial Sync on load
  syncAdjustments();

  // 1. Length, Loft, Lie Listeners
  ['shaft-length-select', 'iron-loft-select', 'iron-lie-select'].forEach(id => {
    document.getElementById(id)?.addEventListener('change', () => {
      syncAdjustments(); // Always pull fresh values from elements
    });
  });

  // 2. Ferrule Listener
  document.getElementById('iron-ferrule-select')?.addEventListener('change', () => {
    syncAdjustments();
    if (typeof updateBuildPrice === 'function') updateBuildPrice();
  });

  // 3. Spine Listener
  document.getElementById('iron-spine-checkbox')?.addEventListener('change', () => {
    syncAdjustments();
    if (typeof updateBuildPrice === 'function') updateBuildPrice();
  });
}



function onIronShaftProductSelected(product) {  
  const selectedIrons = getSelectedIrons();
  // console.log('seelcted shaft product',product)
  if (!selectedIrons.length) return;

  const variants = product.variants || [];

  console.log('buildIronAvailabilityMap: ',buildIronAvailabilityMap(
    variants,
    selectedIrons
  ))
  window.__ironAvailabilityMap = buildIronAvailabilityMap(
    variants,
    selectedIrons
  );

  renderIronFlexOptions(window.__ironAvailabilityMap);

  document.querySelector("#shaft-step .gd-config").classList.remove('has-error');
}

function getShaftDisplayPrice(shaftProduct) {
  if (!shaftProduct) return 0;

  // Explicit zero-upcharge override
  if (shaftProduct.zeroUpcharge === true || shaftProduct.zeroUpcharge === 'true') {
    return 0;
  }

  // Find first available variant with a price
  const firstVariant = (shaftProduct.variants || []).find(v => Number(v.price) > 0)
                    || (shaftProduct.variants || []).find(v => Number(v.price) > 0);

  return firstVariant ? Number(firstVariant.price) : 0;
}


function renderIronFlexOptions(availabilityMap) {
  const container = document.getElementById('iron-flex-options');
  if (!container) return;

  const imgUrl = getProductImage(window.__selectedShaftProduct);
  const lengthConfig = getLengthConfigForCurrentHead();
  const lengthOptionsHtml = buildLengthOptionsHtml(lengthConfig);
  // console.log('availabilityMap',availabilityMap)
  const flexes = Object.keys(availabilityMap);
  const firstFlex = flexes[0];
  const firstModels = Object.keys(availabilityMap[firstFlex] || {});
  const firstModel = firstModels[0];

  // console.log('window.__selectedShaftProduct flexes',flexes)
  const shaftPrice = Math.min(...window.__selectedShaftProduct.variants.map(v => v.price));
  // const shaftPrice = window.__selectedShaftProduct.variants[0].price;
  const shaftDiscount = currentClubConfig?.shaft_discount_amount || 0;
  console.log('shaftPrice',shaftPrice,shaftDiscount)

  // <div class="nbn-shaft-info">
  //         <a href="javascript:void(0)">INFO +</a>
  //       </div>
  container.innerHTML = `
    <div class="nbn-step-card">
      <div class="nbn-step-right">
        <div class="nbn-shaft-price">
          ${getPriceDisplayHTML(shaftPrice, shaftDiscount, window.__selectedShaftProduct.zeroUpcharge, 'shaft')}
        </div>
        <div class="nbn-shaft-image">
          <img src="${imgUrl}" alt="${window.__selectedShaftProduct.productTitle}" loading="lazy" width="420"/>
        </div>
        
        <div class="variant-group">
          <label>Flex</label>
          <div class="variant-radios" data-key="flex">
            ${flexes.map((flex, i) => `
              <label class="iron-flex-option radio-option">
                <input type="radio" name="shaft-variant-options-flex" value="${flex}" ${i === 0 ? 'checked' : ''}>
                <span>${flex}</span>
              </label>
            `).join('')}
          </div>
        </div>

        <div class="variant-group">
          <label>Model</label>
          <div class="variant-radios" data-key="model"></div>
        </div>

        <div class="nbn-shaft-length nbn-custom-select">
          <label>Playing Length</label>
          <select id="shaft-length-select">
            ${lengthOptionsHtml}
          </select>
        </div>

        <!-- Staff-only: Swing Weight + Tipping (empty string for non-staff) -->
        ${buildStaffShaftSpecsHtml()}

        <div id="iron-adjustments" style="display:none;"></div>
      </div>
    </div>
  `;

  renderIronModelOptions(firstFlex, availabilityMap[firstFlex], firstModel);

  renderIronAdjustments();

  bindIronFlexEvents();
  bindIronModelEvents();

  // Staff-only fields were re-created by the innerHTML above; re-bind them.
  bindStaffShaftSpecs(container);

  updateBuildPrice();
  
  document
    .querySelectorAll('#open-shaft-drawer-btn')
    .forEach(btn =>{
      btn.style.display='none';
    });

    document.querySelector("button#open-shaft-drawer").style.display='block';
  
  // console.log('firstFlex',firstFlex,'firstModel',firstModel)

  // 🔹 Force initial selection
  if (firstFlex && firstModel) {
    updateIronShaftSelection(firstFlex, firstModel);
  }
}



function bindIronFlexEvents() {
  document.querySelectorAll('input[name="shaft-variant-options-flex"]').forEach(input => {
    input.addEventListener('change', e => {
      const flex = e.target.value;
      const availabilityMap = window.__ironAvailabilityMap || {};
      const modelsMap = availabilityMap[flex] || {};

      const firstModel = Object.keys(modelsMap)[0];

      // Re-render model radios based on the new flex
      renderIronModelOptions(flex, modelsMap, firstModel);

      if (flex && firstModel) {
        updateIronShaftSelection(flex, firstModel);
      }
    });
  });
}


function bindIronModelEvents() {
  document.querySelectorAll('input[name="shaft-variant-options-model"]').forEach(input => {
    input.addEventListener('change', e => {
      const model = e.target.value;
      const flex = document.querySelector('input[name="shaft-variant-options-flex"]:checked')?.value;

      if (!flex) return;
      updateIronShaftSelection(flex, model);
    });
  });
}



function updateIronShaftSelection(flex, model) {
  const product = window.__selectedShaftProduct;
  if (!product) return;

  const variant = product.variants.find( v => v.flex === flex && v.model === model);
  if (!variant) return;

  const { label, value } = buildVariantOptionSummary(variant.options);

  window.__selectedShaft = {
    ...window.__selectedShaft,
    productId: product.productId,
    productTitle: product.productTitle,
    variantId: variant.variantId,
    flex: variant.flex,
    model: variant.model,
    price: variant.price,
    featuredImage: product.featuredImage,
    optionLabel: label,
    optionValue: value
  };
  
  // ✅ ADD (does not break anything)
  window.__selectedShaftSelection = { flex, model };
  window.__selectedShaftProduct = product;

  // Update label
  updateSelectedShaftLabel(window.__selectedShaft);

  // Update price
  updateBuildPrice();
}


function normaliseIron(iron) {
  if (iron === "PW") return "9i";
  return iron;
}

function capitalizeFlex(val) {
  return val
    .replace(/\+/g, ' +')
    .replace(/\b\w/g, c => c.toUpperCase())
    .replace(/\s+/g, ' ')
    .trim();
}

function buildAvailabilityMap(variants) {
  const map = {};

  variants.forEach(v => {
    if (!map[v.flex]) map[v.flex] = {};
    map[v.flex][v.model] = v.available;
  });

  return map;
}


function extractIronModel(option) {
  // Preferred: explicit value
  if (option.model) return option.model;

  // Fallback: extract from title (Modus 105, 120, etc.)
  const title = option.variantTitle || "";
  const match = title.match(/(\d{2,3})/);
  return match ? match[1] : "";
}


function getMinShaftPrice(product) {
  if (!product.variants?.length) return 0;
  return Math.min(...product.variants.map(v => v.price || 0));
}


function renderGroupedShaftProduct(product, container) {
  // console.log('renderGroupedShaftProduct', product)
  // ============================
  // IRON FLOW → PRODUCT ONLY
  // ============================
  if (isIronProduct()) {
    const card = document.createElement("div");
    card.className = "option_product shaft-product-only";
    card.dataset.productId = product.productId;
    // console.log('drawer product.shortDescription',product.shortDescription);
    const infoHtml = buildInfoAccordion(product.shortDescription);

     // --- 1. INITIAL HIGHLIGHT CHECK ---
    // If this product is already the selected one, add the class immediately
    if (window.__selectedShaft && window.__selectedShaft.productId === product.productId) {
      card.classList.add('current-selected');
    }
    // Inside your shaft loop/render function
    const shaftPrice = Math.min(...product.variants.map(v => v.price));
    // const shaftPrice = product.variants[0].price;
    const shaftDiscount = currentClubConfig?.shaft_discount_amount || 0;

    // console.log('getProductImage(product)',getProductImage(product),product)
    card.innerHTML = `
    <div class="option">
      <div class="option_head">
        <h4 class="title">${product.productTitle}</h4>
        ${getPriceDisplayHTML(shaftPrice, shaftDiscount, product.zeroUpcharge, 'shaft')}
      </div>
      <div class="option_img">
        <img src="${getProductImage(product)}" alt="${product.productTitle}">
      </div>
      ${infoHtml}
      
      </div>
    `;

    //<button class="select-shaft-btn">Select</button>

    card
      //.querySelector(".select-shaft-btn")
      .addEventListener("click", () => {

        // --- 2. UPDATE VISUAL SELECTION STATE ---
        // We target the entire results container to clear selection across ALL sections (Recommended/Others)
        document.querySelectorAll('#shaft-results .option_product').forEach(item => {
          item.classList.remove('current-selected');
        });
        
        // Add class to the clicked element
        card.classList.add('current-selected');

        window.__selectedShaftProduct = product;
        onIronShaftProductSelected(product); // ⬅️ variants handled AFTER
        drawerClose("shaft-drawer");
      });

    container.appendChild(card);
    return;
  }
}


function renderSection(title, products, collapsible = false) {
  if (!products.length) return;

  const container = document.getElementById('shaft-results');

  const section = document.createElement('div');
  section.className = 'shaft-section';

  section.innerHTML = `
    <h3 class="shaft-section-title">${title}</h3>
    <div class="shaft-section-list"></div>
  `;

  const list = section.querySelector('.shaft-section-list');
  products.forEach(p => renderGroupedShaftProduct(p, list));

  if (collapsible) {
    section.classList.add('is-collapsed');
    // hook your "Show All Shafts" button here
  }

  container.appendChild(section);
}


function renderGroupedShaftBuckets(buckets) {
  const container = document.getElementById('shaft-results');
  container.innerHTML = '';

  renderSection(
    'Recommended for You',
    buckets.preSelected.concat(buckets.recommended)
  );

  // console.log('buckets.zeroUpcharge',buckets.zeroUpcharge)
  renderSection(
    'Zero Upcharge Shafts',
    buckets.zeroUpcharge
  );

  renderSection(
    'All Shafts',
    buckets.others,
    true
  );
}



function initShaftDrawer(groupedProducts) {
  const drawer = document.getElementById('shaft-drawer');
  if (!drawer) return;

  // open / close handlers (unchanged)
  document
    .querySelectorAll('#open-shaft-drawer, #open-shaft-drawer-btn')
    .forEach(btn =>
      btn.addEventListener('click', () => drawer.classList.add('active'))
    );

document.addEventListener("click", e => {
  const toggle = e.target.closest(".nbn-info-toggle");
  if (!toggle) return;

  // 🔥 Prevent drawer from closing
  e.stopPropagation();
  e.preventDefault();

  const accordion = toggle.closest(".nbn-info-accordion");
      accordion.classList.toggle("open");
    });


  document.getElementById('close-shaft-drawer')
    ?.addEventListener('click', () => drawer.classList.remove('active'));

  populateGroupedFilters(groupedProducts);
  populateFlexFilterFromGroups(groupedProducts);
  populateFlightSpinFilters(groupedProducts);

  // 🔑 build buckets ONCE
  window.__shaftBuckets = buildInitialShaftOrder(groupedProducts);


  bindGroupedShaftFilters();

  // initial render
  renderGroupedShaftBuckets(window.__shaftBuckets);
  bindShowAllShaftsButton();

  if (isIronProduct()) {
    document
      .querySelectorAll(".shaft-section.is-collapsed")
      .forEach(el => el.classList.remove("is-collapsed"));
  }

}


//Old one
// function updateSelectedShaftLabel(shaft) {
//   // console.log('updateSelectedShaftLabel ',shaft)
//   if (!shaft) return;

//   const el = document.getElementById("selected-shaft-name");
//   if (!el) return;

//   el.innerHTML = `
//     ${shaft.productTitle}<br>
//     <small>
//       <span class="opt-label">${shaft.optionLabel}</span><br>
//       <strong>${shaft.optionValue}</strong>
//     </small>
//   `;
// }

function updateSelectedShaftLabel(shaft) {
  if (!shaft) return;

  const el = document.getElementById("selected-shaft-name");
  if (!el) return;

  // 1. Split and trim the strings
  const labels = shaft.optionLabel.split('/').map(s => s.trim());
  const values = shaft.optionValue.split('/').map(s => s.trim());

  // 2. Generate Label Spans (skipping 'Iron')
  const labelHtml = labels
    .map((label) => {
      if (label.toLowerCase() === 'iron') return null; // Skip Iron label
      return `<span class="opt-label">${label}</span>`;
    })
    .filter(Boolean) // Remove the nulls
    .join(' / ');

  // 3. Generate Value Spans (skipping value associated with 'Iron')
  const valueHtml = values
    .map((val, index) => {
      const labelName = labels[index] ? labels[index].toLowerCase() : '';
      
      if (labelName === 'iron') return null; // Skip Iron value

      const optClass = labelName.replace(/\s+/g, '-');
      return `<span class="opt-value opt-${optClass}">${val}</span>`;
    })
    .filter(Boolean) // Remove the nulls
    .join(' / ');

  el.innerHTML = `
    ${shaft.productTitle}<br>
    <small>
      ${labelHtml}<br>
      <strong>${valueHtml}</strong>
    </small>
  `;

  checkIronsSelectedError();
}


function bindShowAllShaftsButton() {
  const btn = document.getElementById('show-all-shafts-btn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    document
      .querySelectorAll('.shaft-section.is-collapsed')
      .forEach(section => {
        section.classList.remove('is-collapsed');
      });

    btn.style.display = 'none';
  });
}


function applyGroupedShaftFilters() {
  const search = document.getElementById("shaft-search")?.value.toLowerCase() || "";
  const brand  = document.getElementById("filter-brand")?.value || "";
  const flex   = document.getElementById("filter-flex")?.value || "";
  const flight = document.getElementById("filter-flight")?.value || "";
  const spin   = document.getElementById("filter-spin")?.value || "";

  const hasActiveFilter = !!(search || brand || flex || flight || spin);

  const filterFn = list =>
    list
      .map(p => {
        if (brand && p.brand !== brand) return null;
        if (flight && p.ball_flight !== flight) return null;
        if (spin && p.ball_spin !== spin) return null;

        const variants = p.variants.filter(v =>
          (!flex || v.flexGroup === flex) &&
          (!search || p.productTitle.toLowerCase().includes(search))
        );

        return variants.length ? { ...p, variants } : null;
      })
      .filter(Boolean);

  renderGroupedShaftBuckets({
    preSelected: filterFn(window.__shaftBuckets.preSelected),
    recommended: filterFn(window.__shaftBuckets.recommended),
    zeroUpcharge: filterFn(window.__shaftBuckets.zeroUpcharge),
    others: filterFn(window.__shaftBuckets.others)
  });

  // 🔥 KEY FIX: auto-expand when filtering
  if (hasActiveFilter) {
    document
      .querySelectorAll(".shaft-section.is-collapsed")
      .forEach(el => el.classList.remove("is-collapsed"));
  }
}


function bindGroupedShaftFilters() {
  [
    'shaft-search',
    'filter-brand',
    'filter-flex',
    'filter-flight',
    'filter-spin'
  ].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;

    el.addEventListener('input', applyGroupedShaftFilters);
    el.addEventListener('change', applyGroupedShaftFilters);
  });
}

function populateGroupedFilters(groupedProducts) {
  const brandSelect = document.getElementById('filter-brand');
  const flexSelect  = document.getElementById('filter-flex');

  if (!brandSelect || !flexSelect) return;

  // Reset (keep first placeholder option)
  brandSelect.length = 1;
  flexSelect.length = 1;

  // --- Brand (product-level) ---
  const brands = new Set();
  groupedProducts.forEach(p => {
    if (p.brand) brands.add(p.brand);
  });

  [...brands].sort().forEach(brand => {
    const o = document.createElement('option');
    o.value = brand;
    o.textContent = brand;
    brandSelect.appendChild(o);
  });

  // --- Flex (variant-level) ---
  const flexes = new Set();
  groupedProducts.forEach(p => {
    p.variants.forEach(v => {
      if (v.flexFilter) flexes.add(v.flexFilter);
    });
  });

  [...flexes].sort().forEach(flex => {
    const o = document.createElement('option');
    o.value = flex;
    o.textContent = flex.replace(/-/g, ' ');
    flexSelect.appendChild(o);
  });
}

function normalizeShaftProfile(value) {
  if (!value) return '';
  const v = String(value).toLowerCase();
  // if (v.includes('.355')) return '.355 taper';
  // if (v.includes('.370')) return '.370 parallel';
  if (v.includes('.355')) return '355';
  if (v.includes('.370')) return '370';
  return '';
}

function flattenShafts(shafts) {
  const flat = [];
  shafts.forEach(p => {
    (p.variants || []).forEach(v => {
      // console.log('p.shortDescription',p)
      const thumb = getShopifyImageUrl(p.featuredImage, { width: 280 });
      flat.push({
        productId: p.id,
        productTitle: p.title,
        variantTitle: v.title,
        featuredImage: thumb,
        variantId: v.id,
        vendor: p.vendor,
        available: p.availableForSale,
        price: v.priceAmount,
        flex: v.flex || '',
        model: v.model || '',
        shaft_profile: p.shaft_profile || '',
        shortDescription: p.shortDescription || '',
        ball_spin: p.ball_spin || '',
        ball_flight: p.ball_flight || '',
        recommended: p.recommended || false,
        zeroUpcharge: p.zeroUpcharge || false,
        options:v.options,
        iron_fit:v.iron_fit || '',
        default_length:v.default_length || '',
        iron_fit:v.iron_fit || [],
        gripthumb:p.gripthumb,
        shaftThumb:p.shaftThumb,
        productType: p.productType || '',
        material:p.material,
      });
    });
  });
  return flat;
}

function groupShaftsByProduct(flatVariants) {
  const map = new Map();

    const headProfile = currentProduct?.metafields?.shaft_profile || "";
    // console.log('headProfile',headProfile)
    const isIron = currentProduct?.type?.toLowerCase().includes("iron");
    // console.log('isIron',isIron,currentProduct?.type?.toLowerCase())
    const activeProfile = normalizeShaftProfile(headProfile);
    // console.log('activeProfile',activeProfile,normalizeShaftProfile(headProfile))

    const filteredVariants = flatVariants.filter(v => {
      const shaftProdType = slugify(v.productType || "");
      const shaftProfile = normalizeShaftProfile(v.shaft_profile);
      const shaftMaterial = (v.material || "").toLowerCase();

      if (shaftProdType === "iron-shaft") {
        // --- 0.355 Heads: Graphite universal, Steel restricted to .355 ---
        if (activeProfile === "355") {
          if (shaftMaterial === "graphite") {
            return shaftProfile === "355" || shaftProfile === "370";
          }
          // Steel → .355 only (excludes .370 Steel)
          return shaftProfile === "355";
        }

        // --- 0.370 Heads: Universal (any profile, any material) ---
        if (activeProfile === "370") {
          return shaftProfile === "355" || shaftProfile === "370";
        }

        // Iron shaft but no/unknown active profile → show all
        return true;
      }

      // Non-iron shafts (moved out of iron-shaft block — was previously dead code)
      return activeProfile ? shaftProfile === activeProfile : true;
    });

    // console.log('filteredVariants',filteredVariants)
  filteredVariants.forEach(v => {
    const key = v.productId;

    if (!map.has(key)) {
      map.set(key, {
        productId: v.productId,
        productTitle: v.productTitle,
        brand: v.brand || v.vendor,
        ball_flight: v.ball_flight || '',
        ball_spin: v.ball_spin || '',
        recommended: Boolean(v.recommended),
        zeroUpcharge: Boolean(v.zeroUpcharge),
        featuredImage: v.image || v.featuredImage || '',
        shortDescription: v.shortDescription || '',
        gripthumb:v.gripthumb,
        shaftThumb:v.shaftThumb,
        productType: v.productType || '',
        variants: [],
        material:v.material,
      });
    }

    // 🔑 IMPORTANT: preserve EXACT Shopify variant data
    map.get(key).variants.push({
      variantId: v.variantId,

      // DO NOT group / normalise flex
      flex: v.options?.flex || v.flex || '',

      // Weight (model) exactly as Shopify
      model: v.options?.model || v.model || '',

      // Iron identifier
      iron: v.options?.iron || v.iron || '',

      // Raw iron_fit JSON/string (parsed later)
      iron_fit: v.iron_fit || [],

      price: Number(v.price) || 0,
      available: Boolean(v.available),
      default_length: v.default_length || '',
      options: v.options || {},
      variantTitle:v.variantTitle
    });
  });

  return [...map.values()];
}


function populateFlexFilterFromGroups(groupedProducts) {
  const select = document.getElementById('filter-flex');
  if (!select) return;

  select.length = 1; // keep "All Flexes"

  const groups = new Set();

  groupedProducts.forEach(p => {
    p.variants.forEach(v => {
      if (v.flexGroup) groups.add(v.flexGroup);
    });
  });

  [...groups].forEach(group => {
    const o = document.createElement('option');
    o.value = group;
    o.textContent = group;
    select.appendChild(o);
  });
}

function buildLengthOptionsHtml(lengthConfig) {
  // console.log('lengthConfig: ',lengthConfig)
  if (!lengthConfig) return '<option>No lengths available</option>';

  return lengthConfig.length_values
    .map(val => {
      const selected =
        val === lengthConfig.default_length ? 'selected' : '';
      return `<option ${selected}>${val}</option>`;
    })
    .join('');
}




document.addEventListener("click", e => {
  const btn = e.target.closest(".nbn-info-toggle");
  if (!btn) return;

  const accordion = btn.closest(".nbn-info-accordion");
  accordion.classList.toggle("open");
});

document.addEventListener("click", e => {
  if (e.target.closest(".nbn-info-content")) {
    e.stopPropagation();
  }
});



function getSelectedDexterity() {
  const active = document.querySelector('.gd-toggle-btn[aria-pressed="true"]');
  
  if (!active) return null;

  const handData = active.dataset.hand || ""; // Safety fallback to empty string
  // console.log('Original data-hand:', handData);

  // Check if the string contains "left" or "right" regardless of "Hand" being present
  if (handData.toLowerCase().includes('left')) {
    return 'left';
  } else if (handData.toLowerCase().includes('right')) {
    return 'right';
  }

  return null;
}

//new function
// function buildIronAvailabilityMap(variants, selectedIrons) {
//   const selected = selectedIrons.map(normaliseIronCode);
//   const map = {};

//   variants.forEach(v => {
//     const flex  = v.flex;
//     const model = v.model;
//     if (!flex || !model) return;

//     const optionIron = v.iron ? normaliseIronCode(v.iron) : null;
//     const fitIrons = normaliseIronFit(v); 

//     selected.forEach(selIron => {
//       const supported =
//         selIron === optionIron ||
//         fitIrons.includes(selIron);

//       if (!supported) return;

//       map[flex] ??= {};
//       map[flex][model] ??= new Set();
//       map[flex][model].add(selIron);
//     });
//   });

//   // ✅ CHANGE: Only keep Flexes that match AT LEAST ONE selected iron
//   Object.keys(map).forEach(flex => {
//     const covered = new Set();

//     Object.values(map[flex]).forEach(set =>
//       set.forEach(i => covered.add(i))
//     );

//     // If 'covered' has at least one item, it means it supports part of your selection
//     const hasAnyMatch = covered.size > 0; 
    
//     if (!hasAnyMatch) {
//       delete map[flex];
//     }
//   });

//   return map;
// }

//Original - 06-02-2026
function buildIronAvailabilityMap(variants, selectedIrons) {
  const wedgeTypes = ['pw', 'gw', 'sw', 'lw', 'aw', 'w','uw'];
  
  const selected = [...new Set(
    selectedIrons
      .map(normaliseIronCode)
      .filter(i => i !== 'all')
  )];

  const map = {};

  variants.forEach(v => {
    const flex = v.flex;
    const model = v.model;
    if (!flex || !model) return;

    const shaftIronLabel = (v.iron || "").toLowerCase();
    const fitIrons = normaliseIronFit(v);

    selected.forEach(selIron => {
      // 1. Try Exact Match
      let supported = shaftIronLabel === selIron || 
                      shaftIronLabel.includes(selIron) || 
                      fitIrons.includes(selIron);

      // 2. Waterfall Fallback for Wedges
      if (!supported && wedgeTypes.includes(selIron)) {
        // First fallback: Check for 'pw'
        const firstFallback = 'pw';
        supported = shaftIronLabel === firstFallback || 
                    shaftIronLabel.includes(firstFallback) || 
                    fitIrons.includes(firstFallback);

        // Second fallback: Check for '9i'
        if (!supported) {
          const secondFallback = '9i';
          supported = shaftIronLabel === secondFallback || 
                      shaftIronLabel.includes(secondFallback) || 
                      fitIrons.includes(secondFallback);
        }
      }

      if (supported) {
        map[flex] ??= {};
        map[flex][model] ??= new Set();
        map[flex][model].add(selIron);
      }
    });
  });

  // ✅ Validation: Check if model covers all selections
  Object.keys(map).forEach(flex => {
    Object.keys(map[flex]).forEach(model => {
      const modelSet = map[flex][model];
      if (!selected.every(i => modelSet.has(i))) {
        delete map[flex][model];
      }
    });
    if (Object.keys(map[flex]).length === 0) delete map[flex];
  });

  return map;
}

function toggleAllIrons(checked) {
  document.querySelectorAll('.gd-iron-input').forEach(input => {
    if (input.dataset.iron === 'all') return;
    if (input.disabled) return;

    input.checked = checked;
  });

  if (!checked) {
    window.__selectedHeadVariants = [];
  }
}


function syncAllCheckbox() {
  const ironInputs = [...document.querySelectorAll('.gd-iron-input')]
    .filter(i => i.dataset.iron !== 'all' && !i.disabled);

  const allInput = document.querySelector('.gd-iron-input[data-iron="all"]');

  if (!allInput || ironInputs.length === 0) return;

  const allChecked = ironInputs.every(i => i.checked);

  allInput.checked = allChecked;
}


function bindDexterityToggle() {
  const buttons = document.querySelectorAll('.gd-toggle-btn[data-hand]');
  const switchInput = document.querySelector('.gd-switch-input');

  function setDexterity(hand) {
    const btn = [...buttons].find(b => b.dataset.hand === hand);
    if (btn) btn.setAttribute('aria-pressed', 'true');

    if (switchInput) switchInput.checked = hand === 'Left';

    updateIronAvailabilityByDexterity(window.currentProduct);
    updateSelectedIrons();
    updateBuildPrice();
    updateOrderButtonState();
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      setDexterity(btn.dataset.hand);
    });
  });

  if (switchInput) {
    switchInput.addEventListener('change', e => {
      e.stopPropagation();
      setDexterity(switchInput.checked ? 'Left' : 'Right');
    });
  }
}



function bindIronCheckboxLogic() {
  document.querySelectorAll('.gd-iron-input').forEach(input => {
    input.addEventListener('change', e => {
      const iron = e.target.dataset.iron;

      if (iron === 'all') {
        toggleAllIrons(e.target.checked);
      } else {
        syncAllCheckbox();
      }

      updateSelectedIrons();
      updateBuildPrice();
      updateOrderButtonState();
    });
  });
}



function updateSelectedIrons() {
  const product = window.currentProduct;
  const dexterity = getSelectedDexterity();
  // console.log('dexterity',dexterity)
  if (!dexterity) return;

  const checkedIrons = [...document.querySelectorAll('.gd-iron-input')]
    .filter(i => i.checked && i.dataset.iron !== 'all')
    .map(i => i.dataset.iron);

  const variants = product.variants.filter(v =>
    slugify(v.options[0]) === slugify(dexterity) &&
    checkedIrons.includes(v.options[1])
  );

  // console.log('selected irons',variants)
  window.__selectedHeadVariants = variants;
  window.__currentBuild.irons = variants;
}


function updateIronAvailabilityByDexterity(product) {
  const dexterity = getSelectedDexterity();
  if (!dexterity) return;

  console.log('[AVAILABILITY FOR]', dexterity,slugify(dexterity));

  document.querySelectorAll('.gd-iron-input').forEach(input => {
    const iron = input.dataset.iron;
    if (iron === 'all') return;

    // console.log('v',product.variants[0])
    const isAvailable = product.variants.some(v =>
      slugify(v.options[0]) === slugify(dexterity) &&
      slugify(v.options[1]) === slugify(iron)
    );

    // console.log('isAvailable',isAvailable)
    input.disabled = !isAvailable;
    if (!isAvailable) input.checked = false;

    input.closest('.gd-iron-checkbox')
      ?.classList.toggle('is-disabled', !isAvailable);
  });
}


document.addEventListener("click", e => {

  // 1️⃣ Explicitly resolve dexterity inputs only
  const clickedHandBtn = e.target.closest(
    ".gd-toggle-btn[data-hand]"
  );

  const clickedSwitch = e.target.closest(
    ".gd-switch-input:not(.js-advanced-btn)"
  );

  // 🚫 If neither a hand button nor the dexterity switch was clicked → exit
  if (!clickedHandBtn && !clickedSwitch) return;

  const handRow = e.target.closest(".hand-row");
  if (!handRow) return;

  const toggle = handRow.querySelector(".gd-toggle");
  if (!toggle) return;

  const buttons = toggle.querySelectorAll(".gd-toggle-btn[data-hand]");
  if (!buttons.length) return;

  let selectedBtn = null;

  // 2️⃣ Hand button click
  if (clickedHandBtn) {
    selectedBtn = clickedHandBtn;
  }

  // 3️⃣ Switch click
  if (clickedSwitch) {
    const isLeft = clickedSwitch.checked;
    selectedBtn = [...buttons].find(btn =>
      btn.dataset.hand.toLowerCase() === (isLeft ? "left" : "right")
    );
  }
  // console.log('buttons',buttons)
  // console.log('selectedBtn',selectedBtn)

  if (!selectedBtn) return;

  // 🔒 FINAL SAFETY CHECK
  if (!selectedBtn.dataset.hand) return;

  // 4️⃣ Update aria-pressed ONLY for hand buttons
  
  buttons.forEach(b => b.setAttribute("aria-pressed", "false"));
  selectedBtn.setAttribute("aria-pressed", "true");

  // 5️⃣ Sync switch position
  const switchEl = toggle.querySelector(".gd-switch-input");
  if (switchEl) {
    switchEl.checked = selectedBtn.dataset.hand.toLowerCase() === "left";
  }

  // 6️⃣ Update iron availability
  updateIronAvailabilityByDexterity(window.currentProduct);
});




function renderIronModelOptions(flex, modelsMap, preselectModel = null) {
  const wrap = document.querySelector('.variant-radios[data-key="model"]');
  if (!wrap) return;

  const models = Object.keys(modelsMap || {});
  // Use preselectModel if provided and valid, otherwise default to first available
  const selected = (preselectModel && models.includes(preselectModel)) ? preselectModel : models[0];

  wrap.innerHTML = models.map((model) => `
    <label class="iron-model-option radio-option">
      <input type="radio" name="shaft-variant-options-model" value="${model}" ${model === selected ? 'checked' : ''}>
      <span>${model}</span>
    </label>
  `).join('');

  bindIronModelEvents();
}




document.addEventListener('change', e => {
  const input = e.target.closest('input[name="iron-flex"]');
  if (!input) return;

  const flex = input.value;
  const models = window.__ironAvailabilityMap[flex];

  renderIronModelOptions(flex, models);
});


document.addEventListener('change', e => {
  const input = e.target.closest('input[name="iron-model"]');
  if (!input) return;

  const flex = input.dataset.flex;
  const model = input.value;

  const selectedIrons = getSelectedIrons();
  const flatVariants = window.__flatIronVariants;

  const variantsByIron = {};
  const variantIds = [];

  selectedIrons.forEach(iron => {
    const targetIron = normaliseIronCode(iron);

    const v = flatVariants.find(v => {
      if (v.flex !== flex) return false;
      if (v.model !== model) return false;

      const optionIron = normaliseIronCode(v.iron);
      const fitIrons = normaliseIronFit(v).map(normaliseIronCode);

      return optionIron === targetIron || fitIrons.includes(targetIron);
    });

    if (v) {
      variantsByIron[iron] = v.variantId;
      variantIds.push(v.variantId);
    }
  });

  window.__selectedIronSet = {
    flex,
    model,
    irons: selectedIrons,
    variantsByIron,
    variantIds
  };

  console.log('FINAL IRON SET', window.__selectedIronSet);
});

document.addEventListener('change', e => {
  if (e.target.id === 'grip-logo-toggle') {
    window.__selectedGripOptions.logoOrientation =
      e.target.checked ? 'down' : 'up';

    console.log(
      'Grip logo orientation:',
      window.__selectedGripOptions.logoOrientation
    );
  }
});


function bindGripOptionEvents() {
  const logoToggle = document.getElementById("grip-logo-toggle");
  const tapeSelect = document.getElementById("grip-tape-select");

  if (logoToggle) {
    logoToggle.addEventListener("change", e => {
      window.__selectedGripOptions.logoOrientation =
        e.target.checked ? "down" : "up";

      console.log("Grip logo:", window.__selectedGripOptions.logoOrientation);
    });
  }

  if (tapeSelect) {
    tapeSelect.addEventListener("change", e => {
      window.__selectedGripOptions.gripTape = e.target.value;

      console.log("Grip tape:", window.__selectedGripOptions.gripTape);
    });
  }
}

// not in used
// function bindGripExtras() {
//   const tapeSelect = document.getElementById('grip-tape-select');
//   const toggleBtns = document.querySelectorAll('.gd-toggle-btn[data-logoorientation]');
//   const switchInput = document.querySelector('.gd-switch-input');

//   window.__gripExtras = {
//     tape: tapeSelect?.value || '1 Layer (Standard)',
//     logo: 'Up'
//   };

//   tapeSelect?.addEventListener('change', e => {
//     window.__gripExtras.tape = e.target.value;
//   });

//   toggleBtns.forEach(btn => {
//     btn.addEventListener('click', () => {
//       console.log(
//         'toggleBtns',toggleBtns
//       )
//       toggleBtns.forEach(b => b.setAttribute('aria-pressed', 'false'));
//       btn.setAttribute('aria-pressed', 'true');
//       window.__gripExtras.logo = btn.dataset.logoorientation;
//     });
//   });

//   switchInput?.addEventListener('change', e => {
//     const logo = e.target.checked ? 'Down' : 'Up';
//     toggleBtns.forEach(b => b.setAttribute('aria-pressed', b.dataset.logoorientation === logo ? 'true' : 'false'));
//     window.__gripExtras.logo = logo;
//   });
// }



/************
 * Add to cart functions start
 *************/

function toShopifyVariantId(gid) {
  return Number(gid.replace('gid://shopify/ProductVariant/', ''));
}

function markFieldError(el, hasError) {
  if (!el) return;

  const wrapper =
    el.closest('.gd-config') ||
    el.closest('.config-section') ||
    el.parentElement;

    // console.log('wrapper',wrapper)
  wrapper?.classList.toggle('has-error', hasError);
}

function getIronSelectionWrapper() {
  return (
    document.querySelector('.gd-iron-input')?.closest('.irons-row') ||
    document.querySelector('.gd-iron-input')?.parentElement
  );
}

function isBuildComplete({ markErrors = false } = {}) {
  const b = window.__currentBuild;
  const a = window.__ironAdjustments || {};
  const emailInput = document.getElementById('email');
  let valid = true;

  const ironCheckboxes = document.querySelectorAll('.gd-iron-input');
  const anyIronSelected = [...ironCheckboxes].some(cb => cb.checked);

  if (!anyIronSelected) {
    if (markErrors) {
      const wrapper = getIronSelectionWrapper();
      wrapper?.classList.add('has-error');
    }
    valid = false;
  } else if (markErrors) {
    const wrapper = getIronSelectionWrapper();
    wrapper?.classList.remove('has-error');
  }

  // ---- Iron heads
  if (!b || !Array.isArray(b.irons) || b.irons.length === 0) {
    valid = false;
  }

  // ---- Shaft
  if (!b?.shaft) {
    if (markErrors) {
      markFieldError(
        document.getElementById('open-shaft-drawer-btn'),
        true
      );
    }
    valid = false;
  } else if (markErrors) {
    markFieldError(
      document.getElementById('open-shaft-drawer-btn'),
      false
    );
  }

  // ---- Grip
  if (!b?.grip) {
    if (markErrors) {
      markFieldError(
        document.getElementById('open-grip-drawer-btn'),
        true
      );
    }
    valid = false;
  } else if (markErrors) {
    markFieldError(
      document.getElementById('open-grip-drawer-btn'),
      false
    );
  }

  // ---- Adjustments (Iron only)
  if (!a.length || !a.loft || !a.lie) {
    if (markErrors) {
      markFieldError(document.getElementById('iron-loft-select'), !a.loft);
      markFieldError(document.getElementById('iron-lie-select'), !a.lie);
      markFieldError(document.getElementById('shaft-length-select'), !a.length);
    }
    valid = false;
  } else if (markErrors) {
    markFieldError(document.getElementById('iron-loft-select'), false);
    markFieldError(document.getElementById('iron-lie-select'), false);
    markFieldError(document.getElementById('shaft-length-select'), false);
  }

  // ---- Email
  if (!emailInput) return false;

  const email = emailInput.value.trim();
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  if (!emailValid) {
    if (markErrors) {
      markFieldError(emailInput, true);
    }
    valid = false;
  } else if (markErrors) {
    markFieldError(emailInput, false);
  }

  return valid;
}


/* ================================================================
   PHONE NUMBER — capture, validate, normalise
   ----------------------------------------------------------------
   Field markup lives in snippets/nbn-phone-field.liquid (id
   #quote-phone). This block reads it, validates the format and
   normalises to E.164 (+447700900123) so the value is consistent
   whether it reaches a draft order, a cart attribute or the Admin API.

   Guarded on window so the three configurator bundles can never
   collide with a duplicate-declaration SyntaxError.
   ================================================================ */

window.NBNPhone = window.NBNPhone || (function () {

  /* ISO-3166 alpha-2 -> country calling code.
     Only used to expand NATIONAL format input (e.g. 07700 900123).
     Numbers typed with a leading + or 00 bypass this entirely, so an
     absent country here degrades to "please include your country
     code" rather than to a wrong number. Extend as markets open. */
  const DIAL = {
    GB:'44', IE:'353', US:'1', CA:'1', AU:'61', NZ:'64', IN:'91',
    FR:'33', DE:'49', ES:'34', IT:'39', PT:'351', NL:'31', BE:'32',
    LU:'352', CH:'41', AT:'43', DK:'45', SE:'46', NO:'47', FI:'358',
    IS:'354', PL:'48', CZ:'420', SK:'421', HU:'36', RO:'40', BG:'359',
    GR:'30', HR:'385', SI:'386', RS:'381', EE:'372', LV:'371', LT:'370',
    CY:'357', MT:'356', JP:'81', CN:'86', HK:'852', SG:'65', MY:'60',
    TH:'66', KR:'82', TW:'886', PH:'63', ID:'62', VN:'84', AE:'971',
    SA:'966', QA:'974', KW:'965', BH:'973', OM:'968', IL:'972',
    TR:'90', ZA:'27', EG:'20', MA:'212', NG:'234', KE:'254',
    MX:'52', BR:'55', AR:'54', CL:'56', CO:'57', PE:'51'
  };

  function dialFor(cc) {
    return DIAL[String(cc || '').toUpperCase()] || null;
  }

  function defaultCountry(el) {
    return (el && el.dataset && el.dataset.defaultCountry)
      || (window.MARKET_CONTEXT && window.MARKET_CONTEXT.country)
      || (window.Shopify && window.Shopify.country)
      || '';
  }

  /**
   * @returns {{ok:boolean, empty:boolean, e164:string, reason:string}}
   */
  function normalise(raw, countryCode) {
    const input = String(raw == null ? '' : raw).trim();

    if (!input) {
      return { ok: false, empty: true, e164: '', reason: 'Enter a phone number.' };
    }

    if (/[A-Za-z]/.test(input)) {
      return { ok: false, empty: false, e164: '', reason: 'Phone number cannot contain letters.' };
    }

    // Strip the punctuation people actually type.
    let s = input.replace(/[\s().\-\/]/g, '');
    let international = false;

    if (s.charAt(0) === '+') {
      international = true;
      s = s.slice(1);
    } else if (s.slice(0, 2) === '00') {
      international = true;      // 00 is the international access prefix
      s = s.slice(2);
    }

    if (!/^\d+$/.test(s)) {
      return { ok: false, empty: false, e164: '', reason: 'Use digits, spaces and + only.' };
    }

    if (!international) {
      const dial = dialFor(countryCode);
      if (!dial) {
        return {
          ok: false, empty: false, e164: '',
          reason: 'Include your country code, e.g. +44 7700 900123.'
        };
      }
      s = s.replace(/^0+/, '');   // drop the national trunk prefix
      if (!s) {
        return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };
      }
      s = dial + s;
    }

    // E.164 allows a maximum of 15 digits including the country code.
    if (s.length < 8)  return { ok: false, empty: false, e164: '', reason: 'That number looks too short.' };
    if (s.length > 15) return { ok: false, empty: false, e164: '', reason: 'That number looks too long.' };
    if (/^(\d)\1+$/.test(s)) return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };

    return { ok: true, empty: false, e164: '+' + s, reason: '' };
  }

  return { normalise, defaultCountry, dialFor, DIAL };
})();

function getPhoneFieldEl() {
  return document.getElementById('quote-phone');
}

/** Normalised E.164 value, or '' when absent/blank/invalid. */
function getQuotePhone() {
  const el = getPhoneFieldEl();
  if (!el) return '';
  const res = window.NBNPhone.normalise(el.value, window.NBNPhone.defaultCountry(el));
  return res.ok ? res.e164 : '';
}

function showPhoneError(msg) {
  const el = getPhoneFieldEl();
  if (!el) return;
  if (typeof setFieldError === 'function') setFieldError(el, !!msg);
  const errEl = document.getElementById('quote-phone-error');
  if (errEl) {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }
}

/** True when the field is absent, or blank-and-optional, or valid. */
function validatePhoneField() {
  const el = getPhoneFieldEl();
  if (!el) return true;

  const required = el.dataset.required === 'true';
  const raw = (el.value || '').trim();

  if (!raw) {
    if (required) { showPhoneError('Phone number is required.'); return false; }
    showPhoneError('');
    return true;
  }

  const res = window.NBNPhone.normalise(raw, window.NBNPhone.defaultCountry(el));
  showPhoneError(res.ok ? '' : res.reason);
  return res.ok;
}

/* Writes the phone onto the CART as an attribute, so it survives into
   the order as a note attribute. That is the hook a Shopify Flow (or a
   webhook on your app) needs in order to write it back to the customer
   record — the storefront cannot update customer.phone directly. */
async function persistPhoneToCart() {
  // No field on this page — leave whatever the cart already carries alone.
  if (!getPhoneFieldEl()) return;

  // Present but empty clears the attribute ('' removes it), otherwise a number
  // staff deleted would keep riding along on the next quote.
  const phone = getQuotePhone();
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Phone Number': phone } })
    });
  } catch (err) {
    // Never block the add-to-cart on this.
    console.error('Phone attribute update failed', err);
  }
}


/* Validate on blur; while typing, only clear an error that is already
   showing, so the customer is not scolded mid-entry. */
document.addEventListener('blur', function (e) {
  if (e.target && e.target.id === 'quote-phone') validatePhoneField();
}, true);

document.addEventListener('input', function (e) {
  if (!e.target || e.target.id !== 'quote-phone') return;
  const errEl = document.getElementById('quote-phone-error');
  const showing = errEl && !errEl.hidden;
  if (showing) validatePhoneField();
});

function setFieldError(el, hasError) {
  if (!el) return;

  // If the element itself is a row or has a specific class, use it directly.
  // Otherwise, use your existing wrapper logic.
  const wrapper = 
    (el.classList.contains('irons-row') ? el : null) || 
    el.closest('.gd-config') || 
    el.closest('.config-section') || 
    el.parentElement;

  if (hasError) {
    wrapper?.classList.add('has-error');
  } else {
    wrapper?.classList.remove('has-error');
  }
}



function updateOrderButtonState() {
  const btn = document.getElementById('orderSubmitButton');
  if (!btn) return;

  btn.disabled = false;
  btn.classList.remove('is-disabled');
}


/**
 * Checks if irons are required but not yet selected.
 * If invalid, it highlights the iron row and scrolls to it.
 * @returns {boolean} true if irons are missing (error), false if okay.
 */
function checkIronsSelectedError() {
  const b = window.__currentBuild;
  const ironRow = document.querySelector('.gd-row.irons-row');
  const hasIrons = b && b.irons && b.irons.length > 0;
  // console.log('ironRow && !hasIrons',ironRow ,!hasIrons)

  if (ironRow && !hasIrons) {
    console.log('Targeting ironRow for error:', ironRow);
    
    // Use your setFieldError to highlight the row
    setFieldError(ironRow, true);
    
    // Ensure the user sees the error
    ironRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    console.warn("Validation failed: Select irons before proceeding.");
    return true; // Yes, there is an error
  }

  return false; // No error
}

function bindBuildValidation() {
  const triggers = [
    '.gd-iron-input',
    '#shaft-length-select',
    '#email',
    '#fixed-hosel-checkbox',
    '#adaptor-brand-select',
    '#adaptor-model-select',
    '#adaptor-head-select',
    '#adaptor-setting-select'
  ].join(',');

  // Standard Change Listener
  document.addEventListener('change', e => {
    if (e.target.matches(triggers)) {
      updateOrderButtonState();
      
      // If it's an iron checkbox, clear the error from the whole row
      if (e.target.classList.contains('gd-iron-input')) {
        document.querySelector('.gd-row.irons-row')?.classList.remove('has-error');
      } else {
        e.target.closest('.has-error')?.classList.remove('has-error');
      }
    }
  });

  // PREVENT Shaft selection if no Irons are picked
  const shaftBtn = document.getElementById('open-shaft-drawer-btn');
  if (shaftBtn) {
    // Use 'capture' phase to ensure our check happens before the drawer logic
    shaftBtn.addEventListener('click', (e) => {
      checkIronsSelectedError();
    }, true); 
  }

  // Email validation on type
  document.addEventListener('input', e => {
    if (e.target.id === 'email') updateOrderButtonState();
  });

  updateOrderButtonState();
}


function validateBuildAndMarkErrors() {
  let valid = true;
  const b = window.__currentBuild;

  // Iron validation
  const ironOptionsContainer = document.querySelector('.gd-row.irons-row');
  if (ironOptionsContainer) {
    const hasIrons = b.irons && b.irons.length > 0;
    // console.log('ironOptionsContainer',ironOptionsContainer);
    setFieldError(ironOptionsContainer, !hasIrons);
    if (!hasIrons) valid = false;
  }

  // Shaft validation
  const shaftBtn = document.getElementById('open-shaft-drawer-btn');
  if (shaftBtn) {
    setFieldError(shaftBtn, !window.__selectedShaft);
    if (!window.__selectedShaft) valid = false;
  }

  // Grip validation
  const gripBtn = document.getElementById('open-grip-drawer-btn');
  if (gripBtn) {
    setFieldError(gripBtn, !window.__selectedGrip);
    if (!window.__selectedGrip) valid = false;
  }

  // Email validation
  const emailEl = document.getElementById('email');
  if (emailEl) {
    const emailValid = emailEl.value && emailEl.value.includes('@');
    setFieldError(emailEl, !emailValid);
    if (!emailValid) valid = false;
  }

  // Phone number (rendered by snippets/nbn-phone-field.liquid)
  if (!validatePhoneField()) valid = false;

  return valid;
}


// function resolveShaftVariantForIron(shaftProduct, selection, ironCode) {
//   if (!shaftProduct || !selection || !ironCode) return null;

//   // 1. Normalise the iron code (e.g., 'PW' becomes '9i')
//   const targetIron = normaliseIronCode(ironCode);

//   return shaftProduct.variants.find(v => {
//     // 2. Match Flex and Model exactly
//     const matchBase = v.flex === selection.flex && v.model === selection.model;
//     if (!matchBase) return false;

//     // 3. Match the Iron Identifier (Improved to check for substrings)
//     // This catches "9i/PW" if targetIron is "9i"
//     const shaftIronLabel = (v.iron || "").toLowerCase();
//     const matchIron = shaftIronLabel === targetIron || shaftIronLabel.includes(targetIron);

//     // 4. Match the Iron Fit (Normalise fitArray codes as well)
//     let matchFit = false;
//     if (v.iron_fit) {
//       const fitArray = normaliseIronFit(v); // Using your existing helper
//       matchFit = fitArray.includes(targetIron);
//     }

//     return matchIron || matchFit;
//   }) || null;
// }

//fixed on 26-02-2026
function resolveShaftVariantForIron(shaftProduct, selection, ironCode) {
  if (!shaftProduct || !selection || !ironCode) return null;

  const targetIron = normaliseIronCode(ironCode);
  const wedgeTypes = ['pw', 'gw', 'sw', 'lw', 'aw', 'w','uw'];

  const findVariant = (identifier) => {
    return shaftProduct.variants.find(v => {
      const matchBase = v.flex === selection.flex && v.model === selection.model;
      if (!matchBase) return false;

      const shaftIronLabel = (v.iron || "").toLowerCase();
      return shaftIronLabel === identifier || 
             shaftIronLabel.includes(identifier) || 
             normaliseIronFit(v).includes(identifier);
    });
  };

  // 1. Priority: Exact Match (e.g., SW -> SW)
  let selectedVariant = findVariant(targetIron);

  // 2. Priority: PW Fallback (e.g., SW -> PW)
  if (!selectedVariant && wedgeTypes.includes(targetIron)) {
    selectedVariant = findVariant('pw');
  }

  // 3. Priority: 9i Fallback (e.g., SW -> 9i)
  if (!selectedVariant && wedgeTypes.includes(targetIron)) {
    selectedVariant = findVariant('9i');
  }

  return selectedVariant || null;
}

function mapBuildPayloadToDraftItems(buildPayload) {
  return buildPayload.items.map(item => ({
    variant_id: Number(item.id),
    quantity: item.quantity,
    attributes: Object.entries(item.properties || {}).map(
      ([key, value]) => ({
        key,
        value: String(value)
      })
    )
  }));
}

/* ================================================================
   STAFF-ONLY BUILD SPECS  (iron configurator)
   ----------------------------------------------------------------
   Swing Weight + Tipping     -> rendered in renderIronFlexOptions(),
                                 directly under Playing Length.
   Total Weight + Head Weight -> rendered in Liquid, in .order_footer.

   All four are optional. Blank fields are omitted from the payload,
   so a non-staff build is byte-identical to what it was before.

   Globals are window-guarded so this file can coexist with
   nbn-custom-latest.js without a duplicate-declaration SyntaxError.
   ================================================================ */

window.NBN_SWING_WEIGHTS = window.NBN_SWING_WEIGHTS || [
  'C0','C1','C2','C3','C4','C5','C6','C7','C8','C9',
  'D0','D1','D2','D3','D4','D5','D6','D7','D8','D9',
  'E0','E1','E2','E3','E4','E5'
];

window.NBN_STAFF_TOOLTIP_DEFAULTS = window.NBN_STAFF_TOOLTIP_DEFAULTS || {
  swing_weight: 'The balance of the finished club on the Lorythmic scale. Higher letters and numbers feel heavier in the head through the swing.',
  tipping:      'Length trimmed from the tip of the shaft before installation. Tipping stiffens the shaft and typically lowers launch and spin.',
  total_weight: 'The weight of the fully assembled club \u2014 head, shaft, grip and any added weighting combined.',
  head_weight:  'The weight of the club head on its own, before the shaft and grip are fitted.'
};

// renderIronFlexOptions() wipes #iron-flex-options via innerHTML whenever a
// new shaft product is chosen, so entered values are cached and restored.
window.__staffSpecs = window.__staffSpecs || { swingWeight: '', tipping: '' };

function getStaffTooltipText(key) {
  const overrides = window.NBN_STAFF_TOOLTIPS || {};
  const override = overrides[key];

  // Explicit null = deliberately hide this tooltip.
  if (override === null) return '';

  // Blank/whitespace means "nothing configured" (e.g. an empty theme
  // setting), so fall through to the default rather than suppressing it.
  if (typeof override === 'string' && override.trim() !== '') return override;

  return window.NBN_STAFF_TOOLTIP_DEFAULTS[key] || '';
}

function isStaffCustomer() {
  if (typeof window.staffCustomer !== 'undefined') return !!window.staffCustomer;
  // Fallback: the Liquid staff block only renders for tagged customers.
  return !!document.querySelector('[data-nbn-staff-only]');
}

function buildStaffShaftSpecsHtml() {
  if (!isStaffCustomer()) return '';

  const sw  = window.__staffSpecs.swingWeight || '';
  const tip = window.__staffSpecs.tipping || '';

  const options = window.NBN_SWING_WEIGHTS
    .map(v => `<option value="${v}" ${v === sw ? 'selected' : ''}>${v}</option>`)
    .join('');

  return `
    <div class="nbn-staff-specs" data-nbn-staff-only>
      <div class="nbn-shaft-swingweight nbn-custom-select">
        <label>Swing Weight</label>
        <select id="staff-swing-weight">
          <option value="">&mdash; Not set &mdash;</option>
          ${options}
        </select>
        <button class="nbn-info-btn" type="button" aria-label="Swing Weight info">
          i
          <div class="nbn-tooltip">
            <p>${getStaffTooltipText('swing_weight')}</p>
          </div>
        </button>
      </div>

      <div class="nbn-shaft-tipping nbn-custom-select">
        <label>Tipping</label>
        <div class="nbn-input-wrap">
          <input
            type="number"
            id="staff-tipping"
            inputmode="decimal"
            step="0.25"
            min="0"
            placeholder="0"
            value="${tip}"
          >
          <span class="nbn-unit">in</span>
        </div>
        <button class="nbn-info-btn" type="button" aria-label="Tipping info">
          i
          <div class="nbn-tooltip">
            <p>${getStaffTooltipText('tipping')}</p>
          </div>
        </button>
      </div>
    </div>
  `;
}

function bindStaffShaftSpecs(container) {
  if (!container || !isStaffCustomer()) return;

  container.querySelector('#staff-swing-weight')?.addEventListener('change', e => {
    window.__staffSpecs.swingWeight = e.target.value;
  });

  container.querySelector('#staff-tipping')?.addEventListener('input', e => {
    window.__staffSpecs.tipping = e.target.value;
  });
}

/**
 * Staff spec properties for the cart payload. Blank fields are omitted.
 */
function getStaffBuildSpecs() {
  if (!isStaffCustomer()) return {};

  const read = id => (document.getElementById(id)?.value || '').trim();

  // Live DOM first, cache as fallback (shaft card may not be rendered yet).
  const swingWeight = read('staff-swing-weight') || window.__staffSpecs.swingWeight || '';
  const tipping     = read('staff-tipping')      || window.__staffSpecs.tipping      || '';
  const totalWeight = read('staff-total-weight');
  const headWeight  = read('staff-head-weight');

  return {
    ...(swingWeight && { 'Swing Weight': swingWeight }),
    ...(tipping     && { 'Tipping': `${tipping}"` }),
    ...(totalWeight && { 'Total Weight': `${totalWeight}g` }),
    ...(headWeight  && { 'Head Weight': `${headWeight}g` })
  };
}

function getSelectedGripTape() {
  const el = document.getElementById('grip-tape-select');
  return el && el.value ? el.value : null;
}

function getSelectedLogoOrientation() {
  const active = document.querySelector(
    '#grip-step .gd-toggle-btn[data-logoorientation][aria-pressed="true"]'
  );
  return active ? active.dataset.logoorientation : null;
}


function getSelectedNativeVariantId() {
  const input = document.querySelector('form[action="/cart/add"] [name="id"]');
  return input ? Number(input.value) : null;
}
/**
 * Returns selected product/variant info based on format:
 * 'both'  -> "Product Title - Variant Title"
 * 'variant' -> "Variant Title"
 * 'product' -> "Product Title"
 */
function getSelectedVariantTitle(format = 'variant') {
  const selectedId = getSelectedNativeVariantId();
  
  if (!selectedId || !window.currentProduct || !window.currentProduct.variants) {
    return null;
  }

  const variant = window.currentProduct.variants.find(v => v.id === selectedId);
  if (!variant) return null;

  const productTitle = window.currentProduct.title;
  const variantTitle = variant.title;

  switch (format) {
    case 'both':
      return `${productTitle} - ${variantTitle}`;
    case 'product':
      return productTitle;
    case 'variant':
    default:
      return variantTitle;
  }
}

function getIronBuildTitles() {
  const productTitle = window.currentProduct.title;
  const irons = window.__currentBuild.irons || [];

  return irons.map(iron => {
    // iron.title usually contains "right / 6i"
    // We combine the Main Product Title with the specific Iron Variant title
    return `${productTitle} - ${iron.title}`;
  });
}

function buildAddToCartPayload(topLineSKU) {
  const build = window.__currentBuild;
  const adj = window.__ironAdjustments || {};
  const gripExtras = window.__gripExtras || {};
  const logo = getSelectedLogoOrientation();
  const gripTape = getSelectedGripTape();

  const items = [];

  const notes = document.querySelector('textarea[name="order_notes"]')?.value || '';
  const staffSpecs = getStaffBuildSpecs(); // {} for non-staff

  // Helper to get config based on club head type
  const currentClubType= window.currentProduct?.type;
  const config = CONFIG.clubs_head_type[currentClubType];

  /* ----------------------------------
     IRON SET GROUPING ID
     ----------------------------------
     One shared id is generated ONCE per add-to-cart call (not per iron),
     so every iron line added in this build — Main heads AND their shaft/
     grip/ferrule/spine components — carries the SAME iron_groupset_id.
     This is a plain line-item property, so unlike Shopify's
     parent_id/parent_relationship it survives into Draft Orders, Orders,
     exports, and any downstream app/integration.

     Generated for EVERY iron build, including a single lone iron. The cart
     decides how to DISPLAY a set (standalone card vs multi-iron super-group)
     by counting how many Main irons share the id — so a lone iron still
     renders as a normal standalone card while still carrying the id in its
     data.
  ---------------------------------- */
  const ironGroupsetId = `ironset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  /* ----------------------------------
     SAFETY / VALIDATION LAYER
  ---------------------------------- */
  build.irons.forEach(iron => {
    const parentVariantId = iron.id; // ✅ Shopify-required

    // console.log('iron.option2',iron.option2)

    const shaftVariant = resolveShaftVariantForIron(
      window.__selectedShaftProduct,
      window.__selectedShaftSelection,
      iron.option2
    );

    if (!shaftVariant) {
      console.error(
        `[IRON BUILD WARNING] No compatible shaft found for ${iron.option2}`,
        {
          flex: window.__selectedShaftSelection?.flex,
          model: window.__selectedShaftSelection?.model
        }
      );
    }
  });

  
  /* ----------------------------------
     PAYLOAD CONSTRUCTION
  ---------------------------------- */
  build.irons.forEach(iron => {
    const parentVariantId = iron.id; // ✅ Shopify-required
    const componentParentId = `ironHead-${iron.id}-${Date.now()}`;
    // This gives you: "Cobra KING MAX - right / 6i"
    const individualTitle = `${currentProduct?.title} - ${iron.title}`;

     /* ----------------------------------
       SHAFT — IRON AWARE (FIXED)
    ---------------------------------- */
    const shaftVariant = resolveShaftVariantForIron(
      window.__selectedShaftProduct,
      window.__selectedShaftSelection,
      iron.option2
    );

    // Parent: Iron head
    // console.log('build.ferrule',build.ferrule)
    items.push({
      id: iron.id,
      quantity: 1,
      properties: {
        // "Top Line SKU":topLineSKU,
        ...(topLineSKU && {"Top Line SKU":topLineSKU}),
        '_component_id': componentParentId,
        '_component_role': 'Main',
        Loft: adj.loft,
        Lie: adj.lie,
        // ── Iron-set super-group linkage ──
        // Only attached when building a multi-iron set; a lone iron Main
        // (no groupset) simply renders as its own standalone group, same
        // as drivers/wedges/putters.
        ...(ironGroupsetId && { 'iron_groupset_id': ironGroupsetId }),
      ...(window.__selectedShaftProduct && shaftVariant != null && {"Shaft":`${window.__selectedShaftProduct.productTitle} - ${shaftVariant.variantTitle}`}),
      ...(window.__selectedGrip && build.grip && {"Grip":`${window.__selectedGrip.productTitle} - ${window.__selectedGrip.optionValue}`}),
      ...(build.spineVariant && {"Spine Alignment":`Yes (+${formatMoney(build.spineVariant.price,"£{{amount}}")})`}),
      ...(build.ferrule != null && {"Ferrule":`${build.ferrule?.title} (+${formatMoney(build.ferrule.price,"£{{amount}}")})`}),

      // Staff-only build specs. Same values on every iron in the set.
      ...staffSpecs,

      ...(notes && { "Notes":notes, }),
      }
    });

   

    // console.log('seected shaftVariant',shaftVariant)

    if (shaftVariant) {

      // Check if the selected shaft type is in the 'shafts_to_pull' list for this club
      const shaftType = window.__selectedShaftProduct.productType; // Adjust based on your data structure
      const hasShaftDiscount = config.shafts_to_pull.includes(shaftType);
      // console.log('hasShaftDiscount',hasShaftDiscount)
      const shaftDiscountVal = hasShaftDiscount ? config.shaft_discount_amount : null;
      // console.log('shaftDiscountVal',shaftDiscountVal)

      items.push({
        id: toShopifyVariantId(shaftVariant.variantId),
        parent_id: parentVariantId, // 🔥 THIS enables nesting
        quantity: 1,
        properties: {
          '_component_parent_id': componentParentId,
          '_component_role': 'Component',
          "For":`${individualTitle}`,
          // ── Iron-set super-group linkage (same id as the Main line) ──
          // Attached to iron COMPONENTS too so the groupset id travels with
          // every iron line (parent + children) into Draft Orders / exports.
          // Grouping itself is unchanged: the cart still groups Main lines by
          // iron_groupset_id and finds children via _component_parent_id.
          ...(ironGroupsetId && { 'iron_groupset_id': ironGroupsetId }),
          ...(adj.length && { 'Playing Length': adj.length || 'Standard',}),
          ...(build.ferrule != null && {"Ferrule":`${build.ferrule?.title} (+${formatMoney(build.ferrule.price,"£{{amount}}")})`}),
          ...(window.__selectedShaftProduct.zeroUpcharge === true || window.__selectedShaftProduct.zeroUpcharge === 'true'
            ? { "_zero_upcharge": true } 
            : (shaftDiscountVal !== null ? { [`_shaft_discount`]: shaftDiscountVal } : {}))
          
        }
      });
    }

    /* ----------------------------------
       GRIP
    ---------------------------------- */
    if (build.grip) {
      const gripType = "Swing Grip"; // You seem to use "Swing Grip" as a standard category
      const hasGripDiscount = config.grips_to_pull.includes(gripType);
      const gripDiscountVal = hasGripDiscount ? config.grip_discount_amount : null;
      items.push({
        id: toShopifyVariantId(build.grip.variant.variantId),
         parent_id: parentVariantId,
        quantity: 1,
        properties: {
          '_component_parent_id': componentParentId,
          '_component_role': 'Component',
          "For":`${individualTitle}`,
          ...(ironGroupsetId && { 'iron_groupset_id': ironGroupsetId }),
          ...( logo && { 'Logo Direction': `Logo ${logo}` } ),
          ...( gripTape && { 'Grip Tape': gripTape } ),
          ...(window.__selectedGrip?.product?.zeroUpcharge === 'true' 
            ? { "_zero_upcharge": true } 
            : (gripDiscountVal !== null ? { [`_grip_discount`]: gripDiscountVal } : {}))
        }
      });
    }

    /* ----------------------------------
       FERRULE
    ---------------------------------- */
    if (build.ferrule) {
      items.push({
        id: build.ferrule.id,
        parent_id: parentVariantId,
        quantity: 1,
        properties: {
          '_component_parent_id': componentParentId,
          '_component_role': 'Component',
          "For":`${individualTitle}`,
          ...(ironGroupsetId && { 'iron_groupset_id': ironGroupsetId }),
          ...((build.ferrule != null && build.ferrule?.title == 'Standard') && {"_ferrule_discount":'true'})
        }
      });
    }

    /* ----------------------------------
       SPINE
    ---------------------------------- */
    if (build.spineVariant) {
      items.push({
        id: build.spineVariant.id,
        parent_id: parentVariantId,
        quantity: 1,
        properties: {
          _component_parent_id: componentParentId,
          _component_role: 'Component',
          "For":`${individualTitle}`,
          ...(ironGroupsetId && { 'iron_groupset_id': ironGroupsetId }),
          'Spine Alignment': `Yes (+${formatMoney(build.spineVariant.price,"£{{amount}}")})`
        }
      });
    }
  });

  return { items };
}


function bindImageDrawerOpener({ imageSelector, drawerSelector }) {
  document.addEventListener('click', e => {
    const img = e.target.closest(imageSelector);
    if (!img) return;

    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    e.preventDefault();
    e.stopPropagation();

    drawer.classList.add('active');
  });
}

/************
 * Add to cart functions ends
 *************/

let isResetting = false;

function resetAdvancedOptions() {
    // 1. STOP if already running to prevent infinite loop
    if (isResetting) return;
    
    isResetting = true; 
    // console.log("Resetting all advanced options...");

    try {
        // 2. Reset Logo Orientation to "Up"
        const logoSwitch = document.querySelector(".nbn-grip-logo .gd-switch-input");
        if (logoSwitch && logoSwitch.checked !== false) {
            logoSwitch.checked = false;
            logoSwitch.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 3. Reset ALL Select Menus (Ferrule, Loft, Lie)
        // 2. Reset Selects with specific defaults
        const selectsToReset = [
            { id: "iron-ferrule-select", defaultIndex: 0 }, // Ferrule usually starts at 0
            { id: "iron-loft-select",    defaultIndex: 4 }, // Standard is at index 4
            { id: "iron-lie-select",     defaultIndex: 4 }  // Standard is at index 4
        ];

        selectsToReset.forEach(config => {
            const el = document.getElementById(config.id);
            if (el && el.selectedIndex !== config.defaultIndex) {
                // console.log(`Resetting ${config.id} to index ${config.defaultIndex}`);
                el.selectedIndex = config.defaultIndex;
                el.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        // 4. Uncheck Spine Alignment
        const spineCheckbox = document.getElementById("iron-spine-checkbox");
        if (spineCheckbox && spineCheckbox.checked !== false) {
            spineCheckbox.checked = false;
            spineCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
    } catch (error) {
        console.error("Error during reset logic:", error);
    } finally {
        // 5. Always unlock the guard at the end
        isResetting = false; 
    }
}

(function () {
  document.addEventListener('DOMContentLoaded', initConfigurator);

  async function initConfigurator() {
    if (!window.currentProduct) return;

  if (window.currentProduct) {
    updateIronAvailabilityByDexterity(window.currentProduct);
    updateSelectedIrons();
    updateBuildPrice();
    updateOrderButtonState();
    
    setTimeout(() => {
      window.__baseProductPrice =
        window.currentProduct?.price
          ? Number(window.currentProduct.price) / 100
          : 0;

      // console.log('[INIT] Base product price:', window.__baseProductPrice);
      const priceEl = document.querySelector('[data-product-price]');

      if (!priceEl) return;
      
      priceEl.textContent = `${theme.currencySymbol}${window.__baseProductPrice.toFixed(2)}`;
      // console.log('[INIT] Base product price:', window.__baseProductPrice);

    },0);
  }


    // Step 1: build variant helpers
    const variants = buildVariants(currentProduct);
    const { dexIndex, ironsIndex } = resolveOptionIndexes(currentProduct);

    // console.log(dexIndex, ironsIndex)

    bindDexterityToggle();

    bindBuildValidation();
    updateOrderButtonState();
    
    const toggle = document.getElementById("advToggle");
    if (!toggle) return;

    // Restore saved state (optional but recommended)
    const saved = localStorage.getItem("nbn_advanced_enabled");
    if (saved === "true") {
      toggle.checked = true;
      document.body.classList.add("nbn-show-advanced");
    }
       

    toggle.addEventListener("change", () => {
      const enabled = toggle.checked;
      document.body.classList.toggle("nbn-show-advanced", enabled);
      // Persist user preference

      // If Advanced is turned OFF, reset the technical options
        if (!enabled) {
            resetAdvancedOptions();
        }

      localStorage.setItem("nbn_advanced_enabled", enabled);      
    });


    bindIronCheckboxLogic();
    bindIronSelectionEvents();
    
    document.getElementById('orderSubmitButton')?.addEventListener('click', async (e) => {
      const submitButton = e.currentTarget;

      // 1️⃣ Validate build
      const isValid = validateBuildAndMarkErrors();
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('.has-error')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        return;
      }

      // 2️⃣ Setup UI & Bridge to Theme Component
      const productForm = document.querySelector('product-form');
      
      // Prevent double-clicks and show theme spinner
      if (submitButton.classList.contains('loading')) return;
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', true);

      const topLineSKU = submitButton.getAttribute('data-toplinesku');
      const buildPayload = buildAddToCartPayload(topLineSKU);
      const isQuotation = submitButton.dataset.mode === 'quotation';

      // 🔹 CASE A: Normal Add to Cart (Integrated with Theme UI)
      if (!isQuotation) {
        try {
          // Get the section IDs the theme expects (e.g., cart-drawer, cart-count)
          const sections = productForm?.getSectionsToRender?.().map((s) => s.section) || [];

          // Store the phone on the cart so it reaches the order.
        await persistPhoneToCart();

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' 
            },
            body: JSON.stringify({
              ...buildPayload,
              sections: sections,
              sections_url: window.location.pathname
            })
          });

          const json = await response.json();

          // Handle Errors using theme's native error logic
          if (json.status) {
            if (productForm?.handleErrorMessage) {
              productForm.handleErrorMessage(json.description);
            } else {
              alert(json.description);
            }

            // Trigger a refresh if it's a validation error (422)
            if (json.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            return;
          }

          // SUCCESS: Tell the theme to render the new cart content (opens drawer)
          if (productForm?.renderContents) {
            productForm.renderContents(json);
          }

          // Final event dispatch to notify other theme listeners
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', {
              product: json.hasOwnProperty('items') ? json.items[0] : json
            });
          }

        } catch (err) {
          console.error('Iron PDP Cart Error:', err);
        } finally {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        return;
      }

      // 🔹 CASE B: Quotation (Draft Order)
      const order_notes = document.querySelector('textarea[name="order_notes"]')?.value || '';
      const draftItems = mapBuildPayloadToDraftItems(buildPayload);

    // Staff-only phone field. getQuotePhone() is '' when absent/blank/invalid,
    // so only attach the key when we have a real number — never send a blank
    // field the app would have to strip out again.
    const quotePhone = getQuotePhone();
    const quoteCustomer = { email: document.getElementById('email')?.value };
    if (quotePhone) quoteCustomer.phone = quotePhone;

    const quotationPayload = {
      shop: Shopify.shop,
      items: draftItems,
      customer: quoteCustomer,
      note: order_notes,
      send_invoice: true,
      // ✅ NEW — market/currency the customer is viewing
      currency:     (window.MARKET_CONTEXT && window.MARKET_CONTEXT.currency) || cart.currency,
      country_code: (window.MARKET_CONTEXT && window.MARKET_CONTEXT.country)  || Shopify.country
    };

      try {
        const res = await fetch(APP_URL + '/api/create-quotation', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(quotationPayload)
        });

        const json = await res.json();
        if (!json.success) throw new Error('Quotation failed');
        alert('Quotation request sent successfully!');
      } catch (err) {
        console.error('Quotation error', err);
        alert('Something went wrong.');
      } finally {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
    });


    initLoftLie();

     // Step 3: fetch shafts + init drawer
    showSectionLoader('shaft-step');
    await initShaftFlow();
    hideSectionLoader('shaft-step');

     // 🔥 Grip MUST be called explicitly
     showSectionLoader('grip-step');
    await initGripFlow();
    hideSectionLoader('grip-step');

    bindImageDrawerOpener({
      imageSelector: '.nbn-shaft-image img',
      drawerSelector: '#shaft-drawer'
    });

    bindImageDrawerOpener({
      imageSelector: '.nbn-grip-image img',
      drawerSelector: '#grip-drawer'
    });

    document.addEventListener("click", (e) => {
      // 1. Check if the clicked element is the overlay
      // console.log('e',e)
      if (e.target.matches(".nbn-drawer-overlay")) {
        
        // 2. Since it's the overlay, we close the drawers
        drawerClose("shaft-drawer");
        drawerClose("grip-drawer");
        
        // Optional: add a specific close for the ferrule drawer if you added one
        // drawerClose("ferrule-drawer"); 
      }
    });

  }
})();